<template>
  <div class="oaExamineInput" ref="oaExamineInputRef" v-loading="fullScreenLoading" element-loading-text="数据加载中" :style="{ minHeight: repeatdialog.visible ? repeatdialog.keys == 1 ? '300px' : '500px' : '' }">
    <template v-if="isAppenPage === 'add'">
          <!-- v-dhtLoading.fullscreen="fullScreenLoading" -->
      <div
        class="oaExamineAllArea"
        v-show="toVeriQueryShow == false && subSuccss === false && !isHtml"
      >
        <!-- 表单区域（表单+流程） -->
        <!-- :style="'width:calc(' + (100 - (flowshow===1 ? 25 : 0)) + '% - '+ (isAi === 1 ? '329px' : '0px') +')'" -->
        <div
          class="wisdomSubmit"
          :style="getLeftWidth()"
        >
          <!-- 表单区域 -->
          <el-scrollbar class="el-menu-scrollbar__wrap inputBoxArea" :style="getBack(themeConfig)">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              :label-position="'top'"
              class="form-class"
              @submit.prevent
            >
              <!-- 主题设计 -->
              <theme
                v-if="isOpenTheme && themeConfig && themeConfig.themeName && themeConfig.themeName !== '默认'"
                :themeConfig="themeConfig"
              />
              <!-- 自定义页面的导航 -->
              <customPageNav
                v-if="customCanvasLength > 1"
                :navType="customInputConfig.navType"
                :currentIndex="customCanvasIndex"
                :canvasLength="customCanvasLength"
                :canvasConfig="customInputConfig.configList"
              />
              <widget-one-layer
                :fiexdCanvasInfo="fiexdCanvasInfo"
                :isFiexdCanvas="isFiexdCanvas"
                v-model:ruleListChild="ruleList"
                v-model:ctoArrayChild="ctoArray"
                :isInput="isInput"
                :modifyId="
                  modifyId || (modify && modify.modifyId) ? modify.modifyId : ''
                "
                :opensafe="opensafe"
                :isSubmit="isSubmit"
                :pdwidth="pdwidth"
                :formdata="formdata"
                :othersObj="othersObj"
                :tipsize="tipsize"
                :layout="layout"
                :approvalId="approvalId"
                :approvingId="$route.query.approvingId || approvingId"
                :associationVisible="associationVisible"
                :themeConfig="themeConfig"
                :modify="modify"
                v-model:cutObj="cutObj"
                :baseSet="baseSet"
                :pageId="pageId"
                :customData="customData"
                :isReadonlyDetails="isReadonlyDetails"
                :isAppenDetailsFeild="isAppenDetailsFeild"
                ref="widgetOneLayerRef"
                @widgetOneLayerEmit="widgetOneLayerEmitFun"
                @detailGoOcr="detailGoOcr"
                @submit="submitForm('ruleForm')"
                @setAi="setAi"
                @updateOtherAppData="updateOtherAppData"
                @updateNumData="updateNumData"
              >
                <el-col :span="layout == 4 || layout === 14 ? 6 : layout == 2 || layout === 12 ? 12 : 24" v-if="iscustom == 1 && isCustomTitle !== false">
                  <el-form-item
                    label="标题"
                    prop="appname"
                    :rules="[{ required: true, trigger: 'false' }]"
                  >
                    <el-input
                      v-model="appname"
                      class="input-details"
                      placeholder="请输入标题"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="layout == 4 || layout === 14 ? 6 : layout == 2 || layout === 12 ? 12 : 24"
                  v-if="linkconfig && linkconfig.open"
                  class="link-config"
                >
                <el-form-item label="选择模式" title="选择模式">
                  <el-radio v-if="linkconfig.terrace" v-model="formdata.linktype" label="0">打开平台页面</el-radio>
                  <el-radio v-if="linkconfig.link" v-model="formdata.linktype" label="1">直接打开链接</el-radio>
                </el-form-item>
                </el-col>
              </widget-one-layer>
              <!--以下为告知流程-->
              <div class="cto-list" v-if="(isNameCto.length > 0 || isShowCto) && ctoArray && ctoArray.install && ctoArray.install.isfree == 1">
                <el-row
                  class="cto-row"
                  :gutter="40"
                  type="flex"
                  style="flex-wrap: wrap;"
                >
                  <el-col
                    :span="24"
                  >
                  <div class="inner" :class="layout ==11 || layout ==12 || layout === 14 ? 'inner' : 'inner inner-layout'">
                      <span class="title">通知对象</span>
                      <div class="list-detail dd">
                        <div
                          class="list-box"
                          v-if="
                            ctoArray &&
                            ctoArray.install &&
                            ctoArray.install.isfree == 1
                          "
                          @click="showCtoList"
                        >
                          <template v-if="checkedFlowArr.length > 0 || checkedRoleArr.length > 0 || checkedArrUser.length > 0 || checkedArrGroup.length > 0">
                            <el-tag closable type="primary" v-for="item in checkedFlowArr" @close="handleCloseFlow(item)" :key="item.organizationId" style="margin:3px">{{item.name}} <span class="choose-type1">组织</span></el-tag>
                            <el-tag closable type="primary" v-for="item in checkedRoleArr" @close="handleCloseRole(item)" :key="item.roleId" style="margin:3px">{{item.name}} <span class="choose-type2">角色</span></el-tag>
                            <el-tag closable type="primary" v-for="item in checkedArrGroup" @close="handleCloseGroup(item)" :key="item.folderId" style="margin:3px">{{item.realname}} <span class="choose-type1">分组</span></el-tag>
                            <el-tag closable type="primary" v-for="item in checkedArrUser" @close="handleCloseUser(item)" :key="item.userId" style="margin:3px">{{item.realname || item.name}}</el-tag>
                          </template>
                          <el-input
                            placeholder="请选择通知对象"
                            :autofocus="false"
                            ref="input"
                            v-model="searchKey"
                            @keyup="debounceCtoSearchKey">
                          </el-input>
                          <div class="fast-btn">
                            <a href="javascript:;" title="组织查找" @click="ctoAdd"><i class="iconfont icon-zuzhijigou"></i></a>
                            <a href="javascript:;" title="批量查找" @click="showBatchSearch"><i class="iconfont icon-kuaisuchazhao"></i></a>
                          </div>
                          <!-- 下拉框 -->
                          <linked-drop-down
                            ref="linkedDropDownRef"
                            @userCheck="handleBatchSearchChild"
                            @closeFlow="(index)=>{handleCloseFlow(ruleListChild[itemInner],index,1)}"
                          >
                          </linked-drop-down>
                        </div>
                        <span
                          class="blueBtn"
                          @click="
                            onCtoMode(
                              APKey === -1
                                ? ctoArray.cto
                                : ctoArray.workflow[APKey].cto,
                              null,
                              2
                            )
                          "
                        >查看全部</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <!--控件和流程分割******以下为流程-->
              <el-form-item
                label="所在部门"
                v-if="ctoArrayDdt.to && ctoArrayDdt.to.length > 0"
                style="padding: 0px 25px 25px"
              >
                <el-select v-model="orgname" @change="changeOrgname">
                  <el-option
                    v-for="org in ctoArrayDdt.to"
                    :key="org.id"
                    :label="org.orgname"
                    :value="org.orgname"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-scrollbar>
          <!-- 表单按钮区域 -->
          <template v-if="!isFiexdCanvas">
            <div
              class="wisdomSubmitBox"
              v-if="!this.$route.query.fromset && formButton != 2"
            >
              <!--this.$route.query.fromset来源模板安装预览，不要提交-->
              <div class="footer">
                <div class="ai-insert" v-if="baseSet && baseSet.isAiInsert">
                  AI识别
                  <el-input
                    v-model="aiInsertText"
                    @keydown.enter="aiInsert()"
                    :class="['ai-input', aiInsertText ? 'ai-input-value' : '']"
                    size="small"
                    placeholder="请输入"></el-input>
                  <span :title="aiInsertText ? '发送' : ''" :class="['btn-submit', aiInsertText ? 'btn-submit-high' : '']" @click="aiInsert()">
                    <el-icon><Top /></el-icon>
                  </span>
                  <span title="ai粘贴导入" class="btn-submit btn-submit-high" @click="pasteInsert()">
                    <i class="WSiconfont WSicon-fuzhiicon paste-icon"></i>
                  </span>
                </div>
                <template v-if="ocrConfig.switch">
                  <div :class="ocrStatus ? 'btn-new-blue' : 'btn-new-blue btn-grey'" @click="backUpload">上传识别</div>
                  <!-- <div :class="ocrStatus ? 'btn-new-blue' : 'btn-new-blue btn-grey'" @click="goAgain">重新识别</div> -->
                </template>
                <el-button
                  v-if="!addbutton || Number(addbutton[0].value) === 0"
                  class="btn-new-blue"
                  @click="submitForm('ruleForm')"
                  :disabled="
                    ((!ctoArray ? true : false || repeatObjSudIs) &&
                      !modifyId &&
                      !modify) ||
                    linkageLoading
                  "
                >
                  {{!addbutton ? '提 交' : addbutton[0].label}}
                </el-button>

                <template
                  v-if="(!modifyId && !modify && isShowExtent !== false && !formButton) && (!addbutton || Number(addbutton[1].value) === 0)
                  "><!--丘要求不要返回和暂存，坚决不加，除非请客吃饭-->
                  <el-button class="btn-new-grey" @click="storageDateF(ruleForm)"
                    >{{!addbutton ? '存为草稿' : addbutton[1].label}}</el-button
                  >
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- 自定义画布的按钮 -->
            <div class="fiexd-canvas-bottom">
              <div v-if="customCanvasLength > 1"
                :class="[customCanvasIndex === 0 ? 'disabled-btn' : 'clickable-btn']"
                @click="customCanvasChange('prve')">{{ fiexdCanvasInfo.navInfo && fiexdCanvasInfo.navInfo.prevText }}</div>
              <div v-if="customCanvasLength === customCanvasIndex + 1" @click="customCanvasSubmit" class="clickable-btn">提 交</div>
              <div v-else @click="customCanvasChange('next')" class="clickable-btn" >{{ fiexdCanvasInfo.navInfo && fiexdCanvasInfo.navInfo.nextText }}</div>
            </div>
          </template>
        </div>

        <!-- ai 框体相关区域 -->
        <div class="ctoAllArea ctoAllArea-ai" v-if="(isAi === 1 || isAi === 3) && aiStatus" :style="getAiAreaStyle()">
          <div class="resize-handle" @mousedown="startResize"></div>
          <chat-box v-if="isAi === 1" :robotConfig="robotConfig.fill" :modelConfig="robotConfig.fill && robotConfig.fill.robot ? robotConfig.fill.robot : []" :appCustomData="customData" @textInsert="textInsert" />
          <draw-box v-else-if="isAi === 3" />
        </div>

        <!-- 处理告知,流程区域 -->
        <div class="ctoAllArea" :class="baseSet && baseSet.flowshow && baseSet.flowshow.width ? 'ctoAllArea-flow' : ''" v-if='flowshow===1 && !modifyId && !modify' :style="[fromTemplate === true ? {display: 'none'} : '',  getFlowWidth()]">
          <!--设置自动审批流程隐藏显示，改成手动了，这个没用-->
          <!-- v-if="
              (ctoArray && isShowTo) ||
              (ctoArray && isShowCto) ||
              (ctoArray && isNameCto.length > 0)
            " -->
          <!-- 流程 -->
          <div class="ctoArray-class">
            <el-scrollbar class="el-menu-scrollbar__wrap" style="height: 100%">
              <!--以下为处理流程-->
              <div style="overflow: hidden">
                <!-- <p class="title">处理流程</p> -->
                <div class="process">
                  <el-timeline style="padding: 15px" pending>
                    <el-timeline-item v-if="!modify && (fqName || fqName === 0)" class="timeline-blue timeline-class">
                      <el-card :body-style="{ padding: '15px' }">
                        <el-row>
                          <el-col :span="22" class="name">
                            {{fqName}}
                          </el-col>
                          <el-col :span="22" class="name-fqr">发起</el-col>
                        </el-row>
                      </el-card>
                    </el-timeline-item>
                    <template v-if="isShowTo">
                      <template v-for="(cto, key) in APKey < 0 ? ctoArray.to : ctoArray.workflow[APKey].user">
                        <el-timeline-item size="large" v-if="cto.user && cto.user.length != 0" :key="cto.id" class="timeline-blue timeline-class">
                          <el-card :body-style="{ padding: '15px' }">
                            <el-row v-if="cto.user.length == 1">
                              <el-col :span="22" class="name">
                                {{ cto.user[0].name || cto.user[0].realname }}
                              </el-col>
                              <el-col :span="2" class="close-right">
                                <i class="el-icon-error"
                                  @click="delMeth(APKey == -1 ? ctoArray.to : ctoArray.workflow[APKey].user, key, 0)" v-if="!cto.mode || cto.type == 5"></i>
                              </el-col>
                            </el-row>
                            <el-row v-else>
                              <el-col :span="24">
                                <template v-for="(orgN, indexf) in cto.user">
                                  {{ indexf == 1 ? "," : "" }}
                                  <span class="name" style="display:inline;" :key="orgN.userId" v-if="indexf < 2">
                                    {{ orgN.name ? orgN.name : orgN.realname }}
                                  </span>
                                </template>
                                <span v-if="cto.user.length > 2" class="name" style="display:inline;">等{{ cto.user.length }}人</span>
                                <span style="color: #666;display:block;">{{ cto.way == 2 ? "或签" : "会签" }}</span>
                              </el-col>
                              <el-col :span="24">
                                <span class="blueBtn" style="line-height: 30px" @click="onCtoMode(cto, key, 1)">查看全部</span>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-timeline-item>
                        <template v-for="(cto1, key1) in cto.organizationids ? cto.organizationidArr : []" :key="cto1.id">
                          <el-timeline-item
                            icon="icon iconfont icon-zuzhijiegou"
                            color="#fff"
                            size="large"
                            class="timeline-green timeline-class"
                          >
                            <el-card>
                              <el-row>
                                <el-col :span="22" class="name">{{ cto1.name }}</el-col>
                                <el-col :span="2" class="close-right">
                                  <i class="el-icon-error" @click="delOrg(APKey == -1 ? ctoArray.to : ctoArray.workflow[APKey].user, key, key1)"></i>
                                </el-col>
                              </el-row>
                            </el-card>
                          </el-timeline-item>
                        </template>
                        <template v-for="(cto1, key1) in cto.roleids ? cto.roleidArr : []" :key="cto1.id">
                          <el-timeline-item                            
                            icon="icon iconfont icon-zuzhijiegou"
                            color="#fff"
                            size="large"
                            class="timeline-green timeline-class"
                          >
                            <el-card>
                              <el-row>
                                <el-col :span="22" class="name">{{ cto1.name }}</el-col>
                                <el-col :span="2" class="close-right">
                                  <i class="el-icon-error" @click="delRole(APKey == -1 ? ctoArray.to : ctoArray.workflow[APKey].user, key, key1)"></i>
                                </el-col>
                              </el-row>
                            </el-card>
                          </el-timeline-item>
                        </template>
                        <el-timeline-item
                          v-if="cto.user1"
                          icon="icon iconfont icon-tianjia1"
                          :key="cto.id"
                          size="large"
                          class="timeline-add timeline-class"
                        >
                          <el-card :body-style="{ padding: '15px' }">
                            <p @click="changeUser(cto, key)" class="blueBtn">
                              添加处理人<span class="errorMsg">{{
                                cto.errorMsg
                              }}</span>
                            </p>
                          </el-card>
                        </el-timeline-item>
                        <el-timeline-item
                          v-if="cto.type == 5"
                          icon="icon iconfont icon-tianjia1"
                          :key="cto.id"
                          size="large"
                          class="timeline-add timeline-class"
                        >
                          <el-card :body-style="{ padding: '15px' }">
                            <p @click="toAdd(cto, APKey)" class="blueBtn">
                              添加处理人<span class="errorMsg">{{
                                cto.errorMsg
                              }}</span>
                            </p>
                          </el-card>
                        </el-timeline-item>
                      </template>
                    </template>
                  </el-timeline>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>

        <!-- 刷卡区域 -->
        <swipe :readcard="readcard" :showCard="showCard" @upSwipe="upSwipe" />

        <el-dialog
          :title="ctoModeDataList.title"
          :append-to-body="true"
          v-model="dialogTableVisible"
          class="dialognewclass"
          width="800px"
          v-if="ctoModeDataList"
        >
          <el-scrollbar style="height: 400px" class="el-menu-scrollbar__wrap">
            <div class="mode-cto-class">
              <!--小方确定名字最多4个子--->
              <ul v-if="ctoModeDataList.ctoOrto == 1">
                <li
                  v-for="cto in ctoModeDataList.list"
                  :key="cto.id"
                  :class="cto.userId ? 'user' : 'org'"
                >
                  <!-- <i class="icon iconfont icon-role"></i> -->
                  <span>{{ cto.realname ? cto.realname : cto.name }}</span>
                  <template
                    v-for="(orgnameL, orgnameI) in orgNameObjFun(cto.orgname)"
                  >
                    <span
                      :key="orgnameL"
                      v-if="orgnameI < 2"
                      class="ellipsis"
                      :title="orgnameL"
                      >{{ orgnameL }}</span
                    >
                  </template>
                </li>
              </ul>
              <ul v-else>
                <li
                  v-for="(cto, key) in ctoModeDataList.list &&
                  ctoModeDataList.list.user
                    ? ctoModeDataList.list.user
                    : []"
                  :key="cto.id"
                  :class="cto.userId ? 'user' : 'org'"
                >
                  <!-- <i class="icon iconfont icon-role"></i> -->
                  <span>{{ cto.realname ? cto.realname : cto.name }}</span>
                  <template
                    v-for="(orgnameL, orgnameI) in orgNameObjFun(cto.orgname)"
                  >
                    <span
                      :key="orgnameL"
                      v-if="orgnameI < 2"
                      class="ellipsis"
                      :title="orgnameL"
                      >{{ orgnameL }}</span
                    >
                  </template>
                  <template v-if="ctoModeDataList.workflow === 1">
                    <p
                      class="delBtn"
                      @click="
                        delMeth(
                          ctoArray.workflow[APKey].user,
                          ctoModeDataList.toIndex,
                          key
                        )
                      "
                      v-if="
                        !ctoModeDataList.list.mode ||
                        ctoModeDataList.list.type == 5
                      "
                    >
                      <i class="el-icon-error"></i>
                    </p>
                  </template>
                  <template v-else>
                    <p
                      class="delBtn"
                      @click="delMeth(ctoArray.to, ctoModeDataList.toIndex, key)"
                      v-if="
                        !ctoModeDataList.list.mode ||
                        ctoModeDataList.list.type == 5
                      "
                    >
                      <i class="el-icon-error"></i>
                    </p>
                  </template>
                </li>
              </ul>
            </div>
          </el-scrollbar>
        </el-dialog>
      </div>
      <div class="no-repeated-submission" v-show="repeatdialog.visible && !isHtml">
        <div class="repeatdialog">
          <div class="repeatstyle" v-if="repeatdialog.keys == 1">
            <p style="font-size: 50px; color: #d44c4c">
              <i class="el-icon-warning"></i>
            </p>
            <p>你已填写，请勿重复提交数据</p>
            <p>
              <el-button v-if="!isDoorAdd" size="small" style="width: 100px" @click="viewRecording">返回 <i class="el-icon-arrow-right"></i></el-button>
            </p>
          </div>
          <div style="text-align: center; padding-top: 7%" v-else-if="repeatdialog.keys == 2">
            <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/NoAccessRights.svg" class="verifi-img" />
            <p style="font-size: 32px; color: #277fd9; padding-top: 40px">
              该应用只支持在手机上使用
            </p>
            <p style="padding-top: 40px">
              <el-button v-if="!isDoorAdd" size="small" @click="viewRecording">返回</el-button>
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="isAppenPage === 'details'">
      <oaExamineAudit ref="AuditOpenChild" class="oaExamineAudit" :open="true"></oaExamineAudit>
    </template>
    <div class="input-page" v-if="isHtml">
      <iframe class="input-page-container" ref="htmlIframe" :src="htmlInfo.url"></iframe>
    </div>
    <!-- 新版提交成功提示页 -->
    <div class="fromeFrameScuess fromeFrameScuess1" v-if="subSuccss">
      <div style="padding-top: 100px;">
<!--      <div v-if="closeReadcard" style="padding-top: 100px;">-->
        <p>
          <img v-if="readcard.addpic" :src="readcard.addpic && readcard.addpic.indexOf('https://') !== -1 ? readcard.addpic : ($url + readcard.addpic || 'https://bigdata.topeti.com/PCRepository/mainPlatform/noData.svg')" style="max-height: 200px;" />
          <img v-else src="https://bigdata.topeti.com/PCRepository/mainPlatform/noData.svg" style="max-height: 200px;" />
        </p>
        <p>{{readcard.addnotic || '提交成功'}}</p>
      </div>
<!--      <div v-else class="">-->
<!--        <p><i class="icon iconfont icon-tongyi"></i></p>-->
<!--        <p>提交成功</p>-->
<!--      </div>-->
      <div v-if="addaction.val !== 3">
        <el-button class="submitBtn" @click="refersh1">继续填写</el-button>
        <el-button
          class="staingBtn"
          v-if="permissionlistObj.myreportformid && !isDoorAdd"
          @click="viewRecording('chakan')"
          >查看个人记录</el-button
        >
        <el-button
          class="staingBtn"
          v-if="isDoorAdd"
          @click="getRecat"
          >查看个人记录</el-button
        >
      </div>
    </div>
    <!-- 组件区域 -->
    <multipleChoice
      ref="multipleChoiceChild"
      v-on:fromMultipleChoice="fromMultipleChoice"
    ></multipleChoice>
    <levelSelect
      ref="levelSelectRef"
      v-on:fromLevelSelect="levelSelectMethod"
    ></levelSelect>
    <VerificationAndQueryInput
      ref="VerificationAndQueryInputRef"
      :approvalId="approvalId"
      :number="0"
      @toVerificationAndQuery="formVerificationAndQuery"
      v-if="!modifyId && !modify && toVeriQueryShow == true"
    ></VerificationAndQueryInput>
    <ocrSet
      v-show="isShowocrSet"
      ref="ocrSetRef"
      @closeOcrStatus="closeOcrStatus"
      @goFormManual="goFormManual"
      @writeOcrData="writeOcrData"
    >
    </ocrSet>
    <faceDetect
      v-show="isShowfaceSet"
      @faceResult="faceResult"
      @clickJump="clickJump"
      ref="faceSetRef">
    </faceDetect>
    <i-agree-box v-if="iAgreePargam.Visible && !modify" :iAgreePargam="iAgreePargam" @iAgreeClose="iAgreeClose" @iAgreeSubmit="iAgreeSubmit"/>
    <div class="is-submit-loading" v-show="isSubmit" :class="isSplitScreen ? 'split-submit' : ''">
      提交中...
    </div>
    <loginInfo @getToken="getToken" @close="loginMethod = 4" :loginMethod="loginMethod" :registerconfig="registerconfig" loginStatus="visitor" :theme-color="themeColor" :isView="loginVisible" />
    <Success-loading :class="[isSplitScreen ? 'split-submit' : '', isSideslip ? 'sideslip-submit' : '']" v-if="!animationStyle || (!animationStyle.value || animationStyle.value !== 2)" :show="isShowSucloading" :animationStyle="animationStyle" />
    <widgetLinkOpen ref="widgetLinkOpen" :linkConfig="linkconfig" :diaSize="pdwidth + '%'" @closeLink="closeLink" />
    <batch-search ref="batchSearchRef" @batchSearchChild="handleBatchSearchChild" />
    <!-- ai识别加载效果 -->
    <div class="drwaer" v-if="aiLoading">
      <div class="wrapper"></div>
    </div>
  </div>
</template>
<!---需要嵌入这个模块，一定需要给个固定大小的区域来并且position:absolute 或者relative-->
<script>
import { nextTick, defineAsyncComponent } from 'vue'
import Axios from 'axios'
import { axiosBase } from '../../api/api';
import widgetOneLayer from './formFillinPageChild/widgetOneLayer'
import { momVal, assignFormdata, unique, setOthersFormdata, copyObj, getConfigFromUrl, defaultValuesForParameterTransmission } from '@/api/utils'
import { getvalidateapproval } from '@/port/clientSide/workbench'
import { ocrscan } from '@/port/clientSide/widgetOneLayer'
import { filesConfig, markdownToHtml, markdownToText } from '@/api/global'
import {goAppId} from '@/lib/color'
import qs from 'qs'
import { ElMessage } from 'element-plus'
import { cloneDeep, debounce } from 'lodash'
import { getLogin, loginAi, addTalk ,getRobotToken } from '@/api/openAi'
import { generateMathRandom } from '@/api/drage'
import { formatDate } from '@/api/global'
import { getaimanageconfig } from '@/port/admins/ai'
import webSocketClass from "@/api/ws";
import { getautofillapprovaldata } from '@/port/admins/ai.js'
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins'
import { getopenuserlist, getopenorganizationlist, getopenrolelist } from '@/port/clientSide/multipleChoice.js'
import { getuserbindlistmsg } from '@/port/clientSide/multipleChoice.js'
import { updateapprovingbyfeild } from "@/port/clientSide/oaExamineAudit";
import { dealInputConfig, getOtherAppConfig, canvasDataVerify, canvasDataIsFull, getOhterSubmitData  } from "@/components/common/detailEdit/fixedCanvas/js/fixedCanvas.util.js";
import { getuserapprovinglist } from "@/port/clientSide/oaExamineAudit";
import { getopenreportformlist } from "@/port/clientSide/workbench";
import { importData } from '@/components/admins/workBench/moreSetting/mycomponent/batchAddition/utils.js'
import { showMyDialog } from "@/components/clientSide/workbench/bulkImportCpn/uploadDialog.js";

export default {
  computed: {
    approvalIdValue(){
      return this.AuditData && this.AuditData.approving && this.AuditData.approving.approvalId
    },
    registerconfig() {
      return this.$store.state.registerconfig
    },
    isShowExtent () {
      let user = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        if (user.accesstoken_external && user.apiurl_external) {
          return false;
        } else {
          return true;
        }
      } else {
        return true
      }
    },
    isShowTo () {
      const ctoArray = this.ctoArray;
      const APKey = this.APKey;
      let isShow = 1;
      if (ctoArray && APKey == '-1' && ctoArray.to.length > 0) {
        ctoArray.to.forEach((toA) => {
          if (toA.user && toA.user.length != 0 || toA.organizationids || toA.roleids || toA.user1 || toA.type == 5) {
            isShow = 2;
          }
        });
      } else {
        console.log("ctoArray==>", ctoArray, APKey)
        if (ctoArray && ctoArray.workflow.length > 0 && APKey != -1 && ctoArray.workflow[APKey].user) {
          ctoArray.workflow[APKey].user.forEach((toB) => {
            if (toB.user && toB.user.length != 0 || toB.organizationids || toB.roleids || toB.user1 || toB.type == 5) {
              isShow = 2;
            }
          });
        }
      }
      if (isShow === 1) {
        return false;
      } else {
        return true;
      }
    },
    isShowCto () {
      const ctoArray = this.ctoArray;
      const APKey = this.APKey;
      let isShow = 1;
      if (ctoArray && ctoArray.install && ctoArray.install.isfree == 1) {
        isShow = 2;
      } else {
        if (ctoArray && ctoArray.cto.length > 0) {
          isShow = 2;
        } else {
          if (ctoArray &&
            ctoArray.workflow[APKey] &&
            ctoArray.workflow[APKey].cto &&
            ctoArray.workflow[APKey].cto.length > 0) {
            isShow = 2;
          }
        }
      }
      if (isShow === 1) {
        return false;
      } else {
        return true;
      }
    },
    customCanvasLength () {
      let len = 0
      if (this.customInputConfig && this.customInputConfig.configList) {
        len = this.customInputConfig.configList.length
      }
      return len
    },
    fiexdCanvasInfo () {
     return this.customInputConfig.configList && this.customInputConfig.configList[this.customCanvasIndex]
    }
  },
  name: 'oaExamineInput',
  // pageId 区分个人还是全部还是关于我的数据 person 个人或者全部数据区分修改使用 external 外联 modify 是否修改 coverVal 进来打开的覆盖值 type 不知道干嘛的（默认1） approvalId 发起应用的id isAllAdd：是否为批量新增并且根据coverVal值去判断 isSideslip: 是否是侧滑 isReadonlyDetails 是否只显示明细组件(并且要走联动)  isAppenDetailsFeild 明细字段里面需要显示的子字段
  props: ['approvalId', 'approvingId', 'type', 'pageId', 'modify', 'person', 'external', 'coverVal','isDoorAdd', 'isAi', 'pdwidth', 'openfunction', 'themeColor', 'allAddInfo', 'isSplitScreen', 'isSideslip', 'isReadonlyDetails', 'pageType', 'customDeskInfo', 'isAppenDetailsFeild'],
  components: {
    multipleChoice: defineAsyncComponent(() => import('@/components/common/multipleChoice.vue')),
    levelSelect: defineAsyncComponent(() => import('@/components/common/levelSelect.vue')),
    widgetOneLayer,
    VerificationAndQueryInput: defineAsyncComponent(() => import('./VerificationAndQueryInput.vue')),
    iAgreeBox: defineAsyncComponent(() => import('./iAgreeBox.vue')),
    ocrSet: defineAsyncComponent(() => import('./ocrSet.vue')),
    faceDetect: defineAsyncComponent(() => import('./faceDetect/index.vue')),
    loginInfo: defineAsyncComponent(() => import('@/components/common/loginInfo.vue')),
    SuccessLoading: defineAsyncComponent(() => import('@/components/common/successLoading.vue')),
    theme: defineAsyncComponent(() => import('@/components/clientSide/formFillinPageChild/theme.vue')),
    customPageNav: defineAsyncComponent(()=>import('@/components/clientSide/formFillinPageChild/customPageNav.vue')),
    widgetLinkOpen: defineAsyncComponent(() => import('./common/widgetLinkOpen.vue')),
    swipe: defineAsyncComponent(() => import('./common/swipe.vue')),
    linkedDropDown: defineAsyncComponent(() => import('./formFillinPageChild/linkedDropDown')),
    batchSearch: defineAsyncComponent(() => import('./formFillinPageChild/batchSearch')),
    chatBox: defineAsyncComponent(() => import('@/components/common/chat/index')),
    drawBox: defineAsyncComponent(() => import('@/components/common/chat/draw.vue')),
    oaExamineAudit: defineAsyncComponent(() => import('./oaExamineAudit.vue')),
  },
  mixins: [parmsMixins],
  data () {
    return {

      opensafe: 0,  // 安全区域
			robot: 1,//当前选用的小易
			robots:[],// AI小易版本列表：0 chatgpt 1 文心一言 2 文心画图
      aiConfigList: [
        {
          name: 'ChatGPT',
          number: 0,
          label: 'AI易问'
        },
        {
          name: '文心一言',
          number: 1,
          label: 'AI易言'
        },
        {
          name: '文心一格',
          number: 2,
          label: 'AI易画'
        },
        {
          name: '通义千问',
          number: 3,
          label: 'AI易写'
        },
        {
          name: '电信 DeepSeek 671B',
          number: 5,
          label: 'dx-deepseek671b'
        },
        {
          name: '官方 DeepSeek R1',
          number: 6,
          label: 'deepseek-reasoner'
        },
        {
          name: '官方 DeepSeek V3',
          number: 7,
          label: 'deepseek-chat'
        }
      ],
      flowshow: 2,
      subSuccss: false, // 改版提交成功弹窗
      // isPop: false, // 提交成功弹窗
      issubmitForm: false,
      appname: '',
      fullScreenLoading: true,
      iscustom: 0,//自定义标题//1自定义0非自定义
      isCustomTitle: undefined, // 新闻模式下是否显示标题
      ruleList: [],//控件数据
      ruleForm: {},
      ruleForm1: {},
      indexM: null,
      removeIndM: null,
      imgList: [],
      ctoArray: null,
      ctoArrayDdt: {},//去重显示
      APKey: -1,//审批流程的Key，用来判断显示哪个组
      toKey: '',
      type5: {},
      isCtoShow: false,//告知Dom显示
      orgname: null,
      itemKey: null,
      relation: true,
      relationUserDataO: null,//联系人控件。选中值
      dataParenTy: '',//区分控件.1:外层，2:明细，3:关联单选，4:明细单选，
      informRelCto: [],//告知
      dialogTableVisible: false,
      ctoModeDataList: null,
      upDataFileState: true,//图片附件上传状态如上传完成与否true为成功
      repeatObj: null,
      repeatObjSudIs: false,
      repeatdialog: { visible: false, keys: 0 },
      modifyId: null,//是否为修改
      tipsIs: false,//是否需要验证提醒数据重复，可以提交
      isInput: 1,//1为发起，2为暂存
      formdata: null, // 值合集
      isNameCto: [],//- 同步告知数据数据模板，记录表单设置同步告知的联系人控件名称
      linkageLoading: false,//跑联动的时候加载效果使用
      othersObj: {},  // 单选框选择了其他的数据存储
      vfandqFormdata: null,
      layout: 2,   // 两列 or 四列布局 默认为两列 2，4为4列
      toVeriQueryShow: false,//- 是否开启过滤验证数据
      associationVisible: {},//根据选项隐藏显示
      permissionlistObj: {},  // 个人数据等权限列表
      formButton: 0,
      iAgreePargam: {}, // 是否有同意弹窗提示
      fromTemplate: false, //true：模板中心右侧内容隐藏
      // 读卡模式
      readcard: {open:false},
      readcardInput: '',
      isReadcard: false,
      closeReadcard: false,
      // 读卡模式 end
      // 提交之后
      addaction: {
        val: 4
      },
      searchKey: '', //通知对象搜索关键字
      submitTime: null,
      submitSuccessLoading: null,
      // 是否打开修改流程 1打开 0未打开
      upopen:0,
      // 需要修改流程的字段
      upfeild:[],
      // 点击编辑进来之后的数据
      beforeFormdata:{},
      isShowSucloading: false,
      themeConfig: {}, // 主题设计的样式
      isOpenTheme: false, // 是否开启主题设计
      // ai 使用
      isAiLoading: false,
      talkId: '',
      userImg: '',
      aiTextarea: 1,
      chaeckAi: null,
			boxVisiable:false,//切换AI的盒子
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
			aiStatus:false,
      // 标题字体
      tipsize: 14,
      isSubmit: false, // 是否一键提交
      animationStyle: null, // 提交动画的配置
      isShowfaceSet: false, //是否显示人脸识别设置
      isShowocrSet: false, //是否显示ocr设置
      ocrConfig: {}, //ocr配置信息
      robotConfig: {}, //AI小易配置信息
      ocrStatus: true, //ocr中台开关是否开启
      checkStatus: true, //ai易录图片识别请求状态
      // 手机端二维码
      vueqrval: '',
      scanOcr: false, //ai易录是否扫码识别
      ocrStep: 1, //ai易录当前步骤
      ocrTime: '', //ocr识别时间
      ocrLoading: false,
      fileOcrImg: {},
      billImg: '',
      imgInfo: {}, //ai易录识别图片的原始宽高
      ocrResultArr: [], //ai易录识别图片返回的数组
      ocrCopyArr: '', //ai易录要复制的文案
      cutObj: {},  // 单多选开启分页模式选中参数
      addbutton: null, // 提交暂存文字（后台来的配置）
      loginVisible: false,
      //组织架构的参数
      checkedFlowArr: [],
      // 分组参数
      checkedArrGroup: [],
      //用户参数
      checkedArrUser:[],
      //角色的参数
      checkedRoleArr: [],
      // 链接配置
      linkconfig: {
        open: false,
        terrace: false,
        link: false,
        field: '',
        openConfig: 'original'
      },
      appProperty: [],
      loginMethod: 4,
      baseSet:{
        grouping: 0, // 0：当前用户 1：当前应用
        flowshow: {
          type: 'merge',
          width: '345px'
        }
      }, // 流程设置新增的JSON
      fqName: '',
      aiIsOpen: 0, // AI小易开启状态 0:关闭 1:展开 2:收起
      examineHeight: 0, // 新增存储高度的变量
      customData: [], // 应用的变量
      isResizing: false,
      startX: 0,
      startWidth: 0,
      minWidth: 390, // 最小宽度
      maxWidth: 2000, // 最大宽度
      aiInsertText: '',
      aiLoading: false,
      insideAdd: null,
      customInputConfig: {}, // 自定义提交页的配置
      customInputAppInfo: {}, // 自定义配置页的表单信息
      isFiexdCanvas: false,
      isCompleteFlip: true,
      customCanvasIndex: 0, // 自定义详情页当前显示的画布下标
      isAppenPage: 'add', // 是否是新增详情页
      showCard: true,
      isAiDrop: false,
      isHtml: false,
      htmlInfo: {
        url: ''
      },
      user: {}
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
    let userMsg = localStorage.getItem("userMsg");
    let user = localStorage.getItem("user");
    if (userMsg) {
      let userMsgInfo = JSON.parse(userMsg);
      this.fqName = userMsgInfo.realname
    }
    if (user) {
      this.user = JSON.parse(user);
    }
    let insideAdd = localStorage.getItem("insideAdd");
    if (insideAdd) {
      this.insideAdd = JSON.parse(insideAdd);
      localStorage.removeItem("insideAdd");
    }
  },
  methods: {
    isInquire(){
      // if (this.baseSet && this.baseSet.isAiInsert) {
        let textInfo = localStorage.getItem('currentTranscription');
        if(textInfo){
            textInfo = JSON.parse(textInfo);
            if(textInfo.isAi){
              this.aiInsertText = textInfo.text;
              this.$nextTick(this.aiInsert())
            }
            localStorage.removeItem('currentTranscription');
        }
      // }
    },
    handleDragOver(event) {
      event.dataTransfer.dropEffect = 'copy'; // 设置拖放效果为复制
      if (!this.isAiDrop) {
        this.isAiDrop = true
        const that = this
        const uploadDialog = showMyDialog({
          approvalId: that.approvalId,
          aiTips: '帮我把文件的数据填写到这张表中',
          onConfirm: (data) => {
            that.aiDropConfirm(data)
            uploadDialog.destroy();
            that.isAiDrop = false
          },
          onCancel: () => {
            uploadDialog.destroy();
            that.isAiDrop = false
          }
        }, 'aiDropUpload')
      }
      event.preventDefault()
    },
    // ai文件拖入导入返回
    aiDropConfirm (data) {
      if (Array.isArray(data) && data.length > 0) {
        this.aiInsert(data[0])
      }
    },
    // el-input-num keyup更新值
    updateNumData(item, val) {
      this.formdata[item.title + '_' + item.type] = val
      console.log("aa--",this.formdata)
    },
    updateOtherAppData (item, val) {
      const formList = this.customInputConfig.dataSource.formList
      if (formList && formList.length > 0) {
        const key = `${item.title}_${item.type}`
        const index = this.appProperty.findIndex(iten => { return `${iten.title}_${iten.type}` === key })
        // 修改的数据不是主表就忽略
        if (index === -1) return false
        formList.forEach(iten => {
          if (iten.parameters) {
            iten.parameters.forEach(param => {
              const formKey = `${param.from.title}_${param.from.type}`
              // 如果这个传参的本表字段等于当前修改的字段
              if (formKey === key) {
                const ohterFormKey = `${param.chooseFrom.title}_${param.chooseFrom.type}`
                // this.$set(this.customInputAppInfo[iten.appid].formdata, ohterFormKey, val)
                this.customInputAppInfo[iten.appid].formdata[ohterFormKey] = val
              }
            })
          }
        })
      }
      const isFull = canvasDataIsFull(this.fiexdCanvasInfo, this.customInputAppInfo)
      // 填完自动翻页
      if (!this.modify && this.isCompleteFlip && this.customInputConfig && this.customInputConfig.isCompleteFlip && isFull) {
        this.customCanvasChange('next')
      }
    },
    openDetail(param) {
      // const param = {
      //   "approving": {
      //       "approvingId": 1056491
      //   },
      //   "userapprovingId": 1421710,
      //   "approvalId": 18934,
      //   "delete": true,
      //   "update": true
      // }
      this.$refs.AuditOpenChild.AuditOpenList(param)
    },
    // 自定义提交页面的修改
    customCanvasChange (type, jumpIndex) {
      this.isCompleteFlip = true
      if (!jumpIndex && jumpIndex !== 0) {
        if (type === 'prve' && this.customCanvasIndex <= 0) return false
        if (type === 'prve') {
          this.isCompleteFlip = false
          this.customCanvasIndex -= 1
        } else {
          const isRequired = this.customInputConfig.isRequired ? canvasDataIsFull(this.fiexdCanvasInfo, this.customInputAppInfo, 'isRequired') : true
          if (isRequired) {
            this.customCanvasIndex += 1
          } else {
            this.$message.warning('必填项未填')
          }
        }
      } else {
        // 跳转的画布和目前一样就不要跳转了
        if (!this.customInputConfig.configList[jumpIndex] || this.currentIndex === jumpIndex) return false
        this.customCanvasIndex = jumpIndex
      }
      // 设置弹窗尺寸
      this.setDiaSize()
      let property = cloneDeep(this.appProperty)
      const canvasConfig = this.customInputConfig.configList[this.customCanvasIndex]
      if (canvasConfig && canvasConfig.fixedCanvasAppid) {
        // 改变画布的模板和数据
        property = cloneDeep(this.customInputAppInfo[canvasConfig.fixedCanvasAppid].property)
        this.formdata = this.customInputAppInfo[canvasConfig.fixedCanvasAppid].formdata
        this.ruleList = dealInputConfig(canvasConfig, property)
      }
    },
    // 自定义提交页面的提交按钮
    async customCanvasSubmit () {
      if (this.isSubmit) return false
      if (Object.keys(this.customInputAppInfo).length > 1) {
        // 多表提交走这边
        // 验证每个画布的必填是否有填写
        const { isPass, errorIndex } = canvasDataVerify(this.customInputConfig.configList, this.customInputAppInfo)
        if (isPass) {
          const submitFormList = []
          const formdata = this.customInputAppInfo[this.approvalId].formdata
          if (formdata) {
            // 是否是修改
            const isModify = this.modify ? true : false
            // 主表的提交信息
            const ruleForm = await this.submitForm('ruleForm', false, { isManyApp: true, formdata })
            const obj = {
              ...formdata,
              ...ruleForm,
              linkedMessage: JSON.stringify([]),
            }
            submitFormList.push(obj)
            // 获取他表的信息
            const dataList = getOhterSubmitData(this.customInputConfig, this.customInputAppInfo, isModify)
            submitFormList.push(...dataList)
            const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
            // 登录状态才能修改
            if (token) {
              this.isShowSucloading = true
              this.isSubmit = true
              if (isModify) {
                this.updateMultipleTables(submitFormList, token)
              } else {
                this.addMultipleTables(submitFormList, token)
              }
            }
          }
        } else {
          this.$message.warning(`第${errorIndex}页数据错误`)
          this.customCanvasChange(null, errorIndex - 1)
        }
      } else {
        this.submitForm('ruleForm')
      }
    },
    // 多表新增
    addMultipleTables (submitFormList, token) {
      const config = {
        headers:{
          'Content-Type':'application/json',
          'accesstoken': token
        },
      };
      Axios.post('/openapi/addapprovalings', submitFormList, config).then(async res => {
        const { code, data } = res.data
        if (code === 0 && Array.isArray(data)) {
          const isError = data.find(item => { return item.code !== 0 })
          if (isError) {
            this.$message.error('提交失败')
            this.cancelSubmit()
          } else {
            await this.setTowSecond(2000)
            this.cancelSubmit()
            this.addSuccess()
          }
        } else {
          this.cancelSubmit()
          this.$message.error('提交失败')
        }
      }).catch(() => {
        this.$message.error('提交错误')
        this.cancelSubmit()
      })
    },
    // 多表修改
    async updateMultipleTables (submitFormList) {
      for(const data of submitFormList) {
        await axiosBase(data, '/api/updateapproving')
      }
      await this.setTowSecond(2000)
      this.cancelSubmit()
      this.setMeter()
      // isDoorAdd 为 true 时可能是仪表盘打开提交的，返回一个特定回去触发刷新
      setTimeout(() => {
        if (this.isDoorAdd) {
          this.$emit('doorUp')
        }
        // 修改成功回去刷新列表数据
        this.$emit('retRefresh');
        this.$emit('inputClose');
      }, 500);
    },
    // ai填表
    async aiInsert (resData, isToQuestion = false) {
      if (this.aiInsertText || resData) {
        const specialType = ['relation-user', 'organization', 'roule', 'number', 'checkbox']
        let code, data, msg
        if (resData && !isToQuestion) {
          code = 0
          data = resData
        } else {
          this.aiLoading = true
          const query = {
            approvalId: this.approvalId,
            question: isToQuestion ? resData : this.aiInsertText,
          }
          const res = await getautofillapprovaldata(query)
          code = res.code
          data = res.data
          msg = res.msg
        }
        try {
          if (code === 0 && typeof data === 'object') {
            const formdata = cloneDeep(this.formdata)
            const keyList = Object.keys(formdata)
            for(const name in data) {
              // 查看是否存在表单模板中
              const resultConfig = this.ruleList.find(item => { return item.name === name })
              let val = data[name]
              // 不存在模板中、只读、隐藏、和空值直接略过
              if (resultConfig && ![2, 3].includes(resultConfig.per) && val) {
                const keys = `${resultConfig.title}_${resultConfig.type}`
                if (keyList.includes(keys)) {
                  // 联系人、组织和角色控件的特殊处理
                  if (specialType.includes(resultConfig.type)) {
                    val = await this.dealAiInsterData(resultConfig, val)
                  } else if (resultConfig.type === 'details') {
                    for (const obj of val) {
                      for(const listKey in obj) {
                        let val = obj[listKey]
                        const listConfig = resultConfig.list.find(item => { return item.name === listKey })
                        if (listConfig) {
                          if (specialType.includes(listConfig.type)) {
                            val = await this.dealAiInsterData(listConfig, val)
                          }
                          obj[`${listConfig.title}_${listConfig.type}`] = val
                        }
                        delete obj[listKey]
                      }
                    }
                  }
                  formdata[keys] = val
                }
              }
            }
            this.$set(this, 'formdata', formdata)
            setTimeout(() => {
              if (this.$refs.widgetOneLayerRef && this.$refs.widgetOneLayerRef.linkageInitiali) {
                this.$refs.widgetOneLayerRef.linkageInitiali(-1)
              }
            }, 500)

          } else {
            let tips = msg
            if (code === 10003) {
              tips = '识别错误，请完善你的描述语句'
            }
            // 如果返回的code 0 data有数据 那就是识别错误 需要自己去提取提示信息
            if (code === 0 && typeof data === 'string') {
              const arr = data.split('```')
              if (arr[1]) tips = arr[1]
            }
            this.$message.warning(tips || '请完善你的描述语句')
          }
          this.aiLoading = false
        } catch (error) {
          console.log(error, 'error')
          this.aiLoading = false
        }
      }
    },
    // 粘贴填表
    async pasteInsert () {
      try {
        // 尝试读取剪贴板文本
        const text = await navigator.clipboard.readText();
        // 对获取到的文本进行清洗，只保留文字
        const cleanText = text.replace(/<[^>]*>?/gm, '');
        if (cleanText) {
          this.aiInsert(cleanText, true)
        } else {
          this.$message.warning('未识别到内容，请重新复制')
        }
      } catch (err) {
        // 处理错误（如用户拒绝授权、浏览器不支持等）
        console.error('读取剪贴板失败:', err);
      }
    },
    async dealAiInsterData (config, val) {
      // 联系人
      if (config.type === 'relation-user') {
        let checkedUserArr = []
        const userRes = await getopenuserlist({ curpage: 0, pagesize: 0, name: val })
        if (userRes.code === 0 && userRes.data.length > 0) {
          // 单选返回第一个
          checkedUserArr = config.singleIsUser === 0 ? [userRes.data[0]] : userRes.data
        }
        // 更多字段
        let moreInfoArr = []
        if (config.isMoreInfo && config.moreInfoArr.length > 0) { // 是否提交用户更多的信息
          moreInfoArr = config.moreInfoArr
        }
        if (moreInfoArr.findIndex(item => { return item.search('部门：') !== -1 }) !== -1) {
          const userIds = checkedUserArr.map(item => { return item.userId })
          const { code, data } = await getuserbindlistmsg({ userIds: userIds.join(',') })
          if (code === 0) {
            checkedUserArr = data
          }
        }
        val = checkedUserArr.map(el => {
          let elObj = {
            realname: el.realname,
            userId: el.userId
          };
          // 如果有组织信息
          if (el.orgname || el['部门']) elObj.orgname = el.orgname || el['部门']
          moreInfoArr.forEach(key => {
            if (elObj[key] === undefined && el[key] !== undefined) {
              if (key === 'phone') { // 手机的话把真实手机号也提交上来
                elObj.realphone = el.realphone
              } else if (key === 'type') {
                // 1226:33  error  'resUser' is not defined
                // elObj.userTip = resUser.userLabel ? resUser.userLabel[el[key]] : {}
              }
              elObj[key] = el[key]
            }
          })
          return elObj
        });
      } else if (config.type === 'organization' || config.type === 'roule') {
        // 组织和角色的处理
        const fn = config.type === 'organization' ? getopenorganizationlist : getopenrolelist
        // 是否多选
        const isRadio = config[config.type === 'organization' ? 'singleIsOrg' : 'singleIsUser'] === 0 ? true : false
        const res = await fn({ curpage: 0, pagesize: 0, name: val })
        if (res.code === 0 && res.data.length > 0) {
          let list = isRadio ? [res.data[0]] : res.data
          list = list.map(el => {
            let obj = {}
            // 组织
            if (config.type === 'organization') {
              obj = {
                name: el.name,
                organizationId: el.organizationId,
                looktype: el.looktype || 0,
                type: el.type
              }
            } else {
              // 角色
              obj = {
                name: el.name,
                roleId: el.roleId
              }
            }
            return obj
          })
          val = list
        }
      } else if (config.type === 'number' && typeof val === 'string') {
        let numbers = '';
        for (let i = 0; i < val.length; i++) {
          if (!isNaN(parseInt(val[i]))) {
            numbers += val[i];
          }
        }
        val = numbers
      } else if (config.type === 'checkbox') {
        val = [val]
      }
      return val || []
    },
    debounceCtoSearchKey: debounce(function () {
      this.ctoSearchKey()
    }, 200),
    upSwipe (val) {
      this.formdata = { ...this.formdata, ...val }
      let index = -1
      if (this.readcard && this.readcard.classify) {
        // 改版之后新的
        for (const i of this.readcard.feildList) {
          const ind = this.ruleList.findIndex(its => (its.title + '_' + its.type) === i.field)
          if (ind !== -1) {
            index = index === -1 ? ind : index > ind ? ind : index
          }
        }
      } else {
        index = this.ruleList.findIndex(its => (its.title + '_' + its.type) === this.readcard.feild)
      }
      if (index !== -1) {
        this.$refs.widgetOneLayerRef.commitReadcard({
          index: index,
          commit: this.readcard.commit
        })
      }

      // 读卡数据过来，判断是去提交还是填写(commit 1 填写页面 2 自动提交)
      // if (this.readcard.commit === 1) {
      //   this.closeReadcard = true
        // this.readcard.open = false
      // }
    },
    // getIdCard () {
    //   Axios('http://localhost:8989/api/ReadMsg').then(res => {
    //     console.log('刷卡返回', res)
    //     // this.$set(this, 'idcCard', res.data)
    //   }).catch(err => { console.log(err) })
    // },
    getFlowWidth () {
      if (this.baseSet && this.baseSet.flowshow) {
        return { width: this.baseSet.flowshow.width }
      }
    },
    closeLink () {
      console.log('closeLink')
      this.$emit('inputClose')
    },
    openLink (config) {
      let str = ''
      if (config.field) {
        const s = config.field.split('.')
        str = this.formdata[s[0]]
      }
      this.$refs.widgetLinkOpen.open(str)
      if (config.openConfig && (config.openConfig === 'dialog' || config.openConfig === 'right')) {
        this.$emit('hideLink')
      } else {
        this.$emit('inputClose')
      }
    },
    getToken(val){
      const obj = {
        accesstoken: val
      }
      localStorage.setItem('visitorUser', JSON.stringify(obj))
      this.submitForm('ruleForm', true)
    },
    getRecat () {
      const url = window.location.origin + '/clientSide/application?approvalId=' + this.approvalId + '&iId=1&source=user&navShow=false&pageId=1'
      window.open(url)
    },
    // 背景
    getBack (config) {
      let obs = {}
      // 如果是固定画布模式下就使用固定画布的设置
      if (this.isFiexdCanvas) {
        const canvasConfig = this.customInputConfig.configList[this.customCanvasIndex]
        obs = {
          boxShadow: canvasConfig.shadow ? 'rgb(201, 201, 201) 1px 1px 5px' : '',
          // height: this.isAutoHeight ? '77%' : '',
        }
        if (canvasConfig.backgroundValue === 0) {
          obs.backgroundColor = canvasConfig.backgroundColor
        } else {
          obs.backgroundImage = `url(${this.$imgurl}${canvasConfig.backgroundImage})`
          obs.opacity = canvasConfig.percentage / 100
        }
      } else {
        // 主题设计里面的背景色设置
        obs = {
          backgroundColor: config.backConfig && config.backConfig === 'color' ? config.backColor : '#F9F9F9'
        }
        if (config.backConfig && config.backConfig === 'back') {
          delete obs.backgroundColor
          obs.backgroundImage = 'url("' + this.$imgurl + '/confiles/' + config.bodyBackground + '")'
        }
      }

      return obs
    },
    // 插入答案
    textInsert (val) {
      if (!this.chaeckAi) return
      let insertCont = val.content
      console.log("this.chaeckAi.type==",this.chaeckAi.type);
      // 富文本控件把markdown转成html格式
      if(this.chaeckAi.type === 'richTextWid'){
        insertCont = markdownToHtml(insertCont)
        console.log("insertCont====",insertCont);

      } else {
        insertCont = markdownToText(insertCont)
      }
      if (this.chaeckAi.type !== 'details') {
        const type = this.chaeckAi.title + '_' + this.chaeckAi.type
        // this.$set(this.formdata, type, ((this.formdata[type] || '') + insertCont))
        this.formdata[type] = ((this.formdata[type] || '') + insertCont)
      } else {
        const values = this.formdata[this.chaeckAi.fType][this.chaeckAi.index][this.chaeckAi.title] || ''
        // this.$set(this.formdata[this.chaeckAi.fType][this.chaeckAi.index], this.chaeckAi.title, values + insertCont)
        this.formdata[this.chaeckAi.fType][this.chaeckAi.index][this.chaeckAi.title] = values + insertCont
      }
      val.event.preventDefault()
    },
    setAi (val) {
      console.log('答案状态变更', val)
      // this.$set(this, 'chaeckAi', val)
      this.chaeckAi = val
    },
    getLeftWidth () {
      if (this.baseSet && this.baseSet.flowshow && this.baseSet.flowshow.width) {
        const w = this.flowshow === 1 && !this.modifyId && !this.modify ? this.baseSet.flowshow.width.substring(0, this.baseSet.flowshow.width.length - 2) : 0
        // const aiWidth = this.isAi && (this.isAi === 1 || this.isAi === 3) && this.aiStatus ? (this.pdwidth >= 80 ? 460 : 320) + 12 : 0
        // 没开启流程
        if(w === 0){
          if(this.isAi !== 1 && this.isAi !== 3){
            return 'width: 100%'
          }
          else{
            return this.robotConfig && Object.keys(this.robotConfig).length && Number(this.robotConfig.fill.aiBoxWidth) !== 100 ? `width:calc(100% - ${Number(this.robotConfig.fill.aiBoxWidth)}%)` : 'width:0'
          }
        }
        else{
          // 获取主区域总宽度          
          if(this.isAi !== 1 && this.isAi !== 3){
            const pdwidth = this.pdwidth || 80; // 默认80
            const widthRatio = pdwidth / 100;
            const browserWidth = window.innerWidth || document.documentElement.clientWidth;
            const eightyPercentWidth = browserWidth * widthRatio;
            let mainareaWidth = eightyPercentWidth - w;
            return `width:${mainareaWidth}px`
          }
          else{
            const mainArea = document.querySelector('.oaExamineAllArea');
            let mainareaWidth = mainArea ? mainArea.offsetWidth - w : 0;
            // 判断是否需要50%宽度
            return this.robotConfig && Object.keys(this.robotConfig).length && Number(this.robotConfig.fill.aiBoxWidth) !== 100
            ? `width:${(mainareaWidth * (Number(this.robotConfig.fill.aiBoxWidth) / 100)) / 2}px`
            : `width:${mainareaWidth}px`
          }
        }
      } else {
        const mainArea = document.querySelector('.oaExamineAllArea');
        const mainareaWidth = mainArea ? mainArea.offsetWidth : 0;
        const flowshow = 100 - (this.flowshow===1 ? 24 : 0)
        const aiWidth = this.robotConfig && Object.keys(this.robotConfig).length && Number(this.robotConfig.fill.aiBoxWidth) !== 100
            ? `${(mainareaWidth * (Number(this.robotConfig.fill.aiBoxWidth) / 100)) / 2}`: '0'
        return 'width:calc(' + flowshow + '% - ' + (this.isAi && (this.isAi === 1 || this.isAi === 3) && this.aiStatus ? aiWidth : 0) + 'px)'
      }
    },
		// 剪切
		cut(msg) {
      console.log(msg)
      if (msg.search('，') !== -1) {
        return
      }
      let text = ''
      let resolution = ''
      let style = ''
      let arr = msg.split(',')
      for (let i = 0; i < arr.length; i++) {
        let check = arr[i].search('：')
        let key = ''
        let value = ''
        if (check !== -1) {
          key = arr[i].substr(0, check)
          value = arr[i].substr(check + 1, arr[i].length)
        } else {
          let _check = arr[i].search(':')
          if (_check !== -1) {
            key = arr[i].substr(0, _check)
            value = arr[i].substr(_check + 1, arr[i].length)
          } else {
            return
          }
        }
        switch (key) {
          case '描述':
            text = value
            break
          case '分辨率':
            resolution = value
            break
          case '风格':
            style = value
            break
        }
      }
      return {
        text: text,
        resolution: resolution,
        style: style
      }
    },
    // 初始化ChatGPTai
    async getAi () {
      if (window.localStorage.getItem('authorization')) {
        const { data} = await getLogin()
        if (data.code === 200) {
          this.addTalkAi(data.data.userId)
        } else {
          this.$message.warning('ai链接失败，请咨询管理员！')
        }
      } else {
        const { data } = await loginAi()
        if (data.code === 200) {
          window.localStorage.setItem('authorization', data.data.token)
          window.localStorage.setItem('talkId', data.data.talkId)
          window.localStorage.setItem('userId', data.data.userId)
          this.addTalkAi(data.data.userId)
        } else {
          this.$message.warning('ai链接失败，请咨询管理员！')
        }
      }
    },
		// 初始化文言一心
		async getWYYX(){
			const usertoken = JSON.parse(localStorage.getItem('user')).accesstoken
			getRobotToken(usertoken).then(res=>{
				console.log(res)
				if (res.data.code === 0) {
					window.localStorage.setItem('wxAuthorization', res.data.data)
				} else {
					this.$message.warning('ai链接失败，请咨询管理员！')
				}
			})
		},
    // 过滤掉<think>标签内容
      extractThinkContent(str) {
      return str.replace(/<think>[\s\S]*?<\/think>/gi, '');
    },
		// 时间处理
    getMillisecond(time) {
      if (time == 0) {
        return 0
      }
      if (time.search('s') !== -1) {
        return parseInt(time.substr(0, time.length - 1)) * 1000
      }
      if (time.search('m') !== -1) {
        return parseInt(time.substr(0, time.length - 1)) * 1000 * 60
      }
      if (time.search('h') !== -1) {
        return parseInt(time.substr(0, time.length - 1)) * 1000 * 60 * 60
      }
    },
    // 添加会话列表
    async addTalkAi (userId) {
      const res = await addTalk({
          name: this.approvalId + generateMathRandom([]),
        userId: userId
      })
      if (res.data.code === 200) {
        console.log('添加会话列表')
        window.localStorage.setItem('talkId', res.data.data.talkId)
        this.talkId = res.data.data.talkId
      } else {
          this.$message.warning('ai链接失败，请咨询管理员！')
        }
    },
    copyToClipboard(content) {
			if (typeof content === 'object') {
        content = content.imgUrl
      }
      const self = this

      if (window.clipboardData) {
        window.clipboardData.setData("text", content);
        self.$message.success('复制成功！')
      } else {
        (function(content) {
          document.oncopy = function(e) {
            e.clipboardData.setData("text", content);
            e.preventDefault();
            document.oncopy = null;
            self.$message.success('复制成功！')
          };
        })(content);
        document.execCommand("Copy");
      }
    },
    closeSetTime () {
      if (this.submitTime) clearTimeout(this.submitTime)
      if (this.submitSuccessLoading) clearTimeout(this.submitSuccessLoading)
      this.removeKey()
    },
    readcardFun (val) {
      console.log('读卡的input', val)
      // 读卡数据填充到值里面
      this.formdata[this.readcard.feild] = JSON.parse(JSON.stringify(this.readcardInput))
      // this.formdata[this.readcard.feild] = val
      const i = this.ruleList.findIndex(its => (its.title + '_' + its.type) === this.readcard.feild)
      if (i !== -1) {
        this.$refs.widgetOneLayerRef.commitReadcard({
          index: i,
          commit: this.readcard.commit
        })
        // 读卡数据过来，判断是去提交还是填写(commit 1 填写页面 2 自动提交)
        if (this.readcard.commit === 1) {
          this.closeReadcard = true
          this.readcard.open = false
        }
      } else {
        this.$message.warning('绑定字段不存在')
      }
      // this.$set(this, 'readcardInput', '')
      this.readcardInput = ''
    },
    readcardFocus () {
      console.log('刷卡，聚焦')
      this.readcardInput = ''
      this.isReadcard = true
    },
    readcardBlur () {
      console.log('刷卡，失焦')
      this.isReadcard = false
    },
    readcardClose () {
      // 如果是正常关闭的话
      if (!this.closeReadcard) {
        this.$emit('inputClose')
        this.readcard = {open:false}
        this.readcardInput = ''
        this.isReadcard = false
        this.closeReadcard = false
      }
      this.removeKey()
    },
    // 查看个人记录
    viewRecording (type) {
      console.log('查看个人记录')
      // 判断url 如果是个人记录相关页面直接走关闭当前页面并提示刷新相关记录方法
      //- 外链点击
      if (type && type === 'chakan' && this.external) {
        this.$parent.$parent.upUrl(2);
        this.$parent.$parent.inputClose();
        return;
      }
      const url = window.location.href;
      if (url.indexOf('clientSide/oaFrame/oaFrame') || url.indexOf('/clientSide/application')) {
        // 是本页，传一个参数回去说要刷新就好了
        this.$emit('retRefresh');
        this.$emit('inputClose');
      } else {
        if (this.permissionlistObj.myreportformid) {
          this.$router.push({
            url: '/clientSide/application',
            query: {
              approvalId: this.approvalId
            }
          })
        } else {
          this.$router.go(-1);
        }
      }
    },
    refersh1 () {
      if (this.closeReadcard) {
        this.closeReadcard = false
        this.readcardInput = ''
        this.isReadcard = false
        this.readcard = {open:false}
      }
      if (this.modify) {
        this.getsubmitformlist(1);
      } else {
        // 去验证从新走流程
        this.whetherShow(1);
      }
      this.subSuccss = false;
      // this.$emit('inputClose')
    },
    // 个人数据页面因为提交变动需要刷新数据
    setRefersh () {
      this.$emit('retRefresh', this.repeat);
    },
    // 刷新

    retUrl () {
      this.$router.go(-1);
    },
    orgNameObjFun (res) {
      if (Array.isArray(res)) {
        return res
      } else {
        return res && res != '' ? res.split(',') : []
      }
    },
    //- 查看告知数据去重
    filtersFun (datas) {
      console.log("过滤数据===>", datas)
      var newDatas = [];
      for (let i = 0; i < datas.length; i++) {
        if (datas[i] && datas[i] != null) {
          let whether = '';
          if (datas[i].userId) {//- 用户
            whether = newDatas.findIndex((item) => { return item.userId === datas[i].userId });
          } else if (datas[i].organizationId) {//- 组织
            whether = newDatas.findIndex((item) => { return item.organizationId === datas[i].organizationId });
          } else if (datas[i].roleId) {//角色
            whether = newDatas.findIndex((item) => { return item.roleId === datas[i].roleId });
          } else if (datas[i].folderId) {//分组
            whether = newDatas.findIndex((item) => { return item.folderId === datas[i].folderId });
          }

          if (whether === -1) {
            newDatas.push(datas[i])
          }
        }

      }
      return newDatas;
    },
    //- 获取表单里面的联系人空间数据
    formGaoziCountFun (formdata = this.formdata) {
      const that = this;
      let formUseDatas = [];
      if (that.isNameCto.length > 0) {
        //- 说明表单里面有同步告知联系人控件
        that.isNameCto.forEach((item) => {
          if (item.indexOf(".") != -1) {
            //- 说明是明细控件
            let titleType = item.split(".");
            let mingxiTitle = titleType[0];
            let kongjianTitle = titleType[1];
            formdata[mingxiTitle].forEach((detail) => {
              formUseDatas = formUseDatas.concat(detail[kongjianTitle]);
            })
          } else {
            //- 一级联系人控件
            formUseDatas = formUseDatas.concat(formdata[item]);
          }
        })
      }
      return formUseDatas
    },
    onCtoMode (res, toIndex, type) {
      const that = this;
      //toIndex这是流程必传属性
      //type=2是告知res数组.type=*是流程res对象
      //type=3是分条件
      that.ctoModeDataList = {};
      if (type === 2) {
        //- 告知流程
        let showdata = JSON.parse(JSON.stringify(res));
        let formUseDatas = that.formGaoziCountFun();
        formUseDatas = formUseDatas.concat(showdata);
        showdata = that.filtersFun(formUseDatas);
        that.ctoModeDataList.list = showdata;
        that.ctoModeDataList.title = '查看告知';
        that.ctoModeDataList.ctoOrto = 1;
        that.dialogTableVisible = true;
      } else {
        that.ctoModeDataList.list = res;
        that.ctoModeDataList.toIndex = toIndex;
        that.ctoModeDataList.title = '查看流程';
        that.dialogTableVisible = true;
      }
      if (type === 3) {
        that.ctoModeDataList.workflow = 1;
        that.dialogTableVisible = true;
      }
    },
    goback (item) {
      this.$confirm('返回后本页面填写的数据将不保存。确定返回？', '提示', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.go(item)
      }).catch(() => {
      });
    },
    changeOrgname (event) {
      let relUserToArr = [];
      let relUserToArrB = []; //分条件
      //分条件。
      if (this.ctoArray.workflow && this.ctoArray.workflow.length > 0) {
        if (this.ctoArray.workflow[0].orgname) {
          this.ctoArray.workflow.forEach((el) => {
            let aArr = [];
            el.user.forEach((el2) => {
              if (el2.type == 7 && el2.user.length > 0) {
                aArr.push(el2);
              }
            });
            if (aArr.length != 0) {
              relUserToArrB.push(aArr);
            }
          });
        }
      } else {
        if (this.ctoArray.to.length != 0 && !this.ctoArray.to[0].orgname) {
          this.ctoArray.to.forEach((el) => {
            if (el.type == 7 && el.user.length > 0) {
              relUserToArr.push(el);
            }
          });
        }
      }
      //流程
      this.ctoArray.to = [];
      if (this.ctoArrayDdt.to.length > 0) {
        this.ctoArrayDdt.to.forEach(e => {
          if (e.orgname == event) {
            this.ctoArray.to = e.user;
          }
        });
      }
      //没有分条件。添加联系人到流程
      if (relUserToArr.length != 0) {
        relUserToArr.forEach((el2) => {
          this.ctoArray.to.forEach((el3) => {
            if (el3.type == 7 && el2.controller == el3.controller) {
              el3.user = el2.user;
            }
          });
        });
      }
      //分条件
      this.ctoArray.workflow = [];
      if (this.ctoArrayDdt.workflow.length > 0) {
        this.ctoArrayDdt.workflow.forEach((el, i) => {
          el.forEach(l => {
            if (l.orgname == event) {
              this.ctoArray.workflow[i] = l;
            }
          });
        });
      }
      //有分条件。添加联系人到流程
      if (relUserToArrB.length > 0) {
        relUserToArrB.forEach((el, index) => {
          el.forEach((el2) => {
            this.ctoArray.workflow[index].user.forEach((el3) => {
              if (el3.controller == el2.controller) {
                el3.user = el2.user;
              }
            });
          });
        });
      }
      this.orgname = event;
    },
    //暂存
    storageDateF () {
      if (this.upDataFileState.type && !this.upDataFileState.upDataFile) {
        this.$message.error('请等待图片附加上传完毕后再提交！');
        return false;
      }
      const ruleLisTparam = this.$refs.widgetOneLayerRef.widgetOneLayerPullData();
      //以下只作数据提交。不做数据逻辑。处理逻辑请到对于的
      let dataList = JSON.parse(JSON.stringify(ruleLisTparam.dataList));
      dataList = JSON.parse(JSON.stringify(dataList));
      dataList.approvalId = this.approvalId || this.$route.query.approvalId;
      // 遍历并删除查询控件（不需要提交查询控件的数据）
      for (const key in dataList) {
        if (key.includes('_query')) {
          delete dataList[key];
        }
      }
      //自定义标题
      if (this.iscustom === 1 && this.isCustomTitle !== false) {
        if (this.appname) {
          dataList.appname = this.appname
        } else {
          dataList.appname = '';
        }
      }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        dataList.upaceid = upaceId
      }
      axiosBase(dataList, "/openapi/addusercache").then(res => {
        if (!res || res.code != 0) {
          this.$message({
            type: "info",
            message: res.msg,
          });
        } else {
          this.$message({
            type: "success",
            message: '暂存成功!'
          });
        }
      })
    },
    iAgreeClose(){
      if (this.iAgreePargam.agreeSwitch&&this.iAgreePargam.showType===1) { // 如果是提交后提示就不要关闭整个发起页，只关闭当前
        this.iAgreePargam.Visible=false
      } else {
        this.$emit('inputClose')
      }
    },
    iAgreeSubmit(item){
      this.iAgreePargam.Visible=false
      if (item){
        this.submitForm()
      }
    },
    dealFeildChange(){
      let flag = false
      // 处理流程设置的字段是否变化
      const data = cloneDeep(this.beforeFormdata)
      const _data = {}
      this.upfeild.forEach(item=>{
        _data[`${item.title}_${item.type}`] = data[`${item.title}_${item.type}`]
      })

      const formdata = cloneDeep(this.formdata)
      try {
        Object.keys(_data).forEach(item=>{
          if (typeof _data[item] === 'string' || typeof _data[item] === 'number' || typeof _data[item] === 'boolean') {
            if (_data[item] !== formdata[item]) {
              throw new Error('End Loop')
            }
          } else if (typeof _data[item] === 'object') {
            if (JSON.stringify(_data[item]) !== JSON.stringify(formdata[item])) {
              throw new Error('End Loop')
            }
          }
        })
      } catch (error) {
        flag = true
      }
      return flag
    },
    //- 提交
    async submitForm (formName, isOpen = false, obj = { isManyApp: false, formdata: this.formdata }) {
      const { isManyApp, formdata } = obj
      // isManyApp是否是多表提交
      // 开始提交
      if (this.issubmitForm) return;
      if (this.openfunction && this.openfunction.loginstatus === 1 && !isOpen) {
        if (this.openfunction.searchstatus === 1) {
          this.loginMethod = 4
        } else {
          this.loginMethod = this.openfunction.loginaction
        }
        this.loginVisible = true
        return
      }
      let self = this;
      setTimeout(function () {
        self.issubmitForm = false;
      }, 2000)
      if (this.upDataFileState.type && !this.upDataFileState.upDataFile) {
        this.$message.error('请等待图片附加上传完毕后再提交！');
        return false;
      }
      //修改没有自定义标题
      if (this.iscustom == 1 && this.isCustomTitle !== false && this.appname == '') {
        this.$message.error('自定义标题不能为空');
        return;
      }

      if (this.iscustom == 1 && this.isCustomTitle !== false) {
        // this.$set(this.ruleForm, 'appname', this.appname);
        this.ruleForm.appname = this.appname
      }
      console.log(this.$refs.widgetOneLayerRef, 'this.$refs.widgetOneLayerRef')
      const ruleLisTparam = this.$refs.widgetOneLayerRef.widgetOneLayerPullData(1)
      console.log("走到", ruleLisTparam)

      if (ruleLisTparam.isCheck == 2) {
        return false;
      }
      // 是否需要二次确认
      if (this.iAgreePargam.agreeSwitch&&this.iAgreePargam.showType===1&&formName&&!this.modify) {
        // this.$set(this.iAgreePargam,'Visible',true)
        this.iAgreePargam.Visible = true
        return false
      }
      //验证是否有验证提交规则
      if (this.tipsIs) {
        let submitData = ruleLisTparam.dataList;
        // 遍历并删除查询控件（不需要提交查询控件的数据）
        for (const key in submitData) {
            if (key.includes('_query')) {
                delete submitData[key];
            }
        }
        submitData.approvalId = this.approvalId || this.$route.query.approvalId;
        submitData.approvingId = this.$route.query.modifyId || this.modify && this.modify.modifyId ? this.modify.modifyId : '';
        axiosBase(submitData, "/openapi/checkdataunique").then(res => {
          if (res.code == 0 && res.data == '-2') {
            //唯一验证的需要修改
            this.$store.commit('upOnly', 'true');
            this.$confirm(res.msg, '提示', {
              confirmButtonClass: 'el-button--yeprimary',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.tipsIs = false;
              this.issubmitForm = false
              this.submitForm()
            });
          } else {
            this.tipsIs = false;
            this.issubmitForm = false
            this.submitForm()
          }
        });
        return false;
      }
      //修改提交
      if ((this.modifyId || this.modify)) {
        // 并且没有修改触发重新发起流程的字段   否则直接走新增方法
        if (!this.dealFeildChange() || this.person == 0) {
          let _api = '/api/updateapproving'
          let submitData = ruleLisTparam.dataList;
          // 遍历并删除查询控件（不需要提交查询控件的数据）
          for (const key in submitData) {
              if (key.includes('_query')) {
                  delete submitData[key];
              }
          }
          if (this.iscustom == 1 && this.isCustomTitle !== false) {//孙家伟需要修改appname，如果不要就把这个删除就行
            submitData.appname = this.appname
          }
          // 在这边处理修改字段后，处理流程
          // let _data = {
          //   approvingDataId:this.$route.query.modifyId || this.modify && this.modify.modifyId ? this.modify.modifyId : ''
          // }
          submitData.approvalId = this.approvalId || this.$route.query.approvalId
          submitData.approvingId = this.$route.query.modifyId || this.modify && this.modify.modifyId ? this.modify.modifyId : '';
          const _date = cloneDeep(submitData)
          for (const key in _date) {
            if (key.includes('_richTextWid')) {
              // 如果说是富文本控件
              const data = _date[key]
              const control = this.appProperty.find(f => f.title === key.split('_')[0])
              if (data === (control && control.bindinf) && control && control.isClearDefaultValue) _date[key] = ''
              else if (data === '<p><br></p>' && control && control.isClearDefaultValue)  _date[key] = ''
            }
          }
          if (isManyApp) return _date
          axiosBase(_date, _api).then(res => {
            if (res.code == 0) {
              ElMessage({ type: "success", message: res.msg })
              // this.$message({ message: res.msg, type: 'success' })
              // this.$router.go(-1);
              // 判断iId 情况
              this.setMeter()
              // isDoorAdd 为 true 时可能是仪表盘打开提交的，返回一个特定回去触发刷新
              setTimeout(() => {
                if (this.isDoorAdd) {
                  this.$emit('doorUp')
                }
                // 修改成功回去刷新列表数据
                this.$emit('retRefresh');
                this.$emit('inputClose');
              }, 500);
            } else {
              ElMessage({ message: res.msg, type: 'info' })
              return false;
            }
          });
          return false;
        }
      }
      var toArr;
      var ctoArr;
      var error = false;
      if (this.APKey == -1) {
        this.ctoArray.to.forEach(e => {
          if (e.type == 2 || e.type == 3) {
            if (e.user.length == 0) {
              error = true
              e.errorMsg = '（请选择审批人）'
            }
          }
        });
        //- 审批提交数据
        toArr = this.ctoArray.to;
        //- 告知提交数据
        let submitdata = this.ctoArray.cto;
        let formUseDatas = this.formGaoziCountFun(formdata);
        formUseDatas = formUseDatas.concat(submitdata);
        ctoArr = this.filtersFun(formUseDatas);
      } else {
        this.ctoArray.workflow[this.APKey].user.forEach(e => {
          if (e.type == 2 || e.type == 3) {
            if (e.user.length == 0) {
              error = true;
              e.errorMsg = '（请选择审批人）'
            }
          }
        });
        //- 审批提交数据
        toArr = this.ctoArray.workflow[this.APKey].user;
        //- 告知提交数据
        let submitdata = this.ctoArray.workflow[this.APKey].cto;
        let formUseDatas = this.formGaoziCountFun(formdata);
        formUseDatas = formUseDatas.concat(submitdata);
        ctoArr = this.filtersFun(formUseDatas);
      }
      if (error) {
        this.$message({ type: "info", message: "请选择审批人!" });
        return
      }
      if (!toArr || toArr.length == 0) {
        this.$message({ type: "info", message: "审批流程未设置!" });
        return
      }
      for (var i = 0; i < toArr.length; i++) {
        if (toArr[i].type == 5) {
          if (toArr[i].user && toArr[i].user.length > 0 || toArr[i].organizationids && toArr[i].organizationids.length > 0 || toArr[i].roleids && toArr[i].roleids.length > 0) {
            //通过
          } else {
            this.$message({ type: "info", message: "请选择审批人!" });
            return
          }
        }
      }
      //告知过滤
      if (Number(this.informRelCto.length) !== 0) {
        let newArr = [];
        ctoArr.forEach((ctoArrEl) => {
          if (Number(newArr.length) === 0) {
            ctoArrEl.informRel && delete (ctoArrEl.informRel);
            newArr.push(ctoArrEl);
          } else {
            let isAdd = 1;
            newArr.forEach((el5) => {
              (ctoArrEl.userId == el5.userId) ? isAdd = 2 : isAdd = 1;
            });
            if (Number(isAdd) === 1) {
              ctoArrEl.informRel && delete (ctoArrEl.informRel);
              newArr.push(ctoArrEl);
            }
          }
        });
        ctoArr = newArr;
      }
      this.ruleForm.to = JSON.stringify(toArr);
      this.ruleForm.cto = JSON.stringify(ctoArr);
      this.ruleForm.install = JSON.stringify(this.ctoArray.install)
      //以上是审批流程设置
      this.ruleForm.approvalId = this.approvalId || this.$route.query.approvalId;
      if (this.$route.query.approvingId || this.approvingId) {
        this.ruleForm.approvingId = this.$route.query.approvingId || this.approvingId;
      }
      if (ruleLisTparam.relWyArr && ruleLisTparam.relWyArr.length > 0) {
        // this.ruleForm.selfuser = JSON.stringify(ruleLisTparam.relWyArr);
      }
      //删除多余参数
      let linkedMessage = [];
      ruleLisTparam.linkedMessageArr.forEach((resD) => {
        let resObl = JSON.parse(JSON.stringify(resD));
        delete resObl.relFormId;
        linkedMessage.push(resObl);
      });
      //以下只作数据提交。不做数据逻辑。处理逻辑请到对于的(linkedMessage 参数只在发起这个页面有，审批没有)
      const dataList = JSON.parse(JSON.stringify(ruleLisTparam.dataList));
      // 遍历并删除查询控件（不需要提交查询控件的数据）
      for (const key in dataList) {
          if (key.includes('_query')) {
              delete dataList[key];
          }
      }
      let ruleFormAdd = Object.assign(dataList, this.ruleForm);
      ruleFormAdd.linkedMessage = JSON.stringify(linkedMessage);
      if (ruleFormAdd.approvalId===11742&&this.$apiurl==='https://xmjyj.topeti.com') { // 如果应用为11742这个资助应用，需要单独跑一个防止数据重复得验证市局
        this.onFundingVerification(ruleFormAdd)
      } else {
        let isBatch = false
        let batchConfig = {}
        let isIncludesDetail = false
        for (const ele of this.ruleList) {
          if (ele.type === 'relation-user' && ele.userBatchAdd && ele.singleIsUser === 1) {
            isBatch = true
            batchConfig = ele
          }
        }
        if (isBatch) {
          const userKey = `${batchConfig.title}_${batchConfig.type}_${batchConfig.name}`
          const dataList = []
          const newFormdata = {}
          for (const key in this.formdata) {
            const title = key.split('_')[0]
            const config = this.ruleList.find(ele => ele.title === title)
            const newKey = `${title}_${config.type}_${config.name}`
            if (key.includes('details')) {
              const li = config.lists
              isIncludesDetail = true
              const detailsLi = []
              for (const cele of this.formdata[key]) {
                const obj = {}
                for (const ckey in cele) {
                  const ctitle = ckey.split('_')[0]
                  const cconfig = li.find(ele => ele.title === ctitle)
                  const cnewKey = `${ctitle}_${cconfig.type}_${cconfig.name}`
                  obj[cnewKey] = cele[ckey]
                }
                detailsLi.push(obj)
              }
              newFormdata[newKey] = detailsLi
            } else {
              newFormdata[newKey] = this.formdata[key]
            }
          }
          const userLi = cloneDeep(newFormdata[userKey])
          for (const ele of userLi) {
            const obj = {
              ...newFormdata,
              [userKey]: [ele]
            }
            dataList.push(obj)
          }
          this.isShowSucloading = true
          this.isSubmit = false
          Promise.all([importData(dataList, { approvalId: this.approvalId, isIncludesDetail }), this.setTowSecond(2000)]).then((res) => {
            if (!res[1]) {
              this.setTableScopeRow(ruleFormAdd)
              this.addSuccess()
            }
          })
        } else {
          let api = '/openapi/addapprovaling'
          if (this.dealFeildChange()) {
            api = '/openapi/adddata'
            ruleFormAdd.approvingDataId = this.$route.query.modifyId || this.modify && this.modify.modifyId ? this.modify.modifyId : ''
          }
          if (this.allAddInfo && this.allAddInfo.isBatchAdd) {
            // 批量新增
            let cover = {
              filedName: '',
              value: []
            }
            for (const key in formdata) {
              const val = formdata[key]
              if (key === this.allAddInfo.filedName) {
                cover.value = JSON.parse(JSON.stringify(val))
                cover.filedName = key
              }
            }
            for (const ele of cover.value) {
              const param = JSON.parse(JSON.stringify(ruleFormAdd))
              const value = JSON.stringify([ele])
              param[cover.filedName] = value
              this.onAddapprovaling(param, api)
            }
          } else {
            if (isManyApp) {
              return this.ruleForm
            } else {
              this.onAddapprovaling(ruleFormAdd,api)
            }
          }
        }
      }
    },
    async onAddapprovaling(ruleFormAdd,api = '/openapi/addapprovaling'){
      // this.fullScreenLoading = true;
      this.isShowSucloading = true
      this.isSubmit = false
      // 从空间进入，需要传空间id
      if(this.isSpace){
        const spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        ruleFormAdd.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        ruleFormAdd.upaceid = upaceId
      }
      const _date = cloneDeep(ruleFormAdd)
      for (const key in _date) {
        if (key.includes('_richTextWid')) {
          // 如果说是富文本控件
          const control = this.appProperty.find(f => f.title === key.split('_')[0])
          const data = _date[key]
          if (data === (control && control.bindinf) && control && control.isClearDefaultValue) _date[key] = ''
        }
      }
      // 欧总要求动画必须走完一遍
      // this.submitSuccessLoading = setTimeout(() => {
      // },2000)
      let second = 2000
      if (api === '/openapi/addapprovaling') {
        const fillquery = {}
        for (const ele of this.paramsList) {
          fillquery[ele.name] = { value: ele.value }
        }
        _date.fillquery = fillquery
        for (const key in _date) {
          if (key.includes('_number') && _date[key] === "") {
            _date[key] = 0
          }
        }
      }
      axiosBase(_date, api).then(async res => {
        await this.setTableScopeRow(ruleFormAdd)
        // 从门户那边过来，有设置站内应用列表新增的传参
        await this.setTowSecond(second)
        // 欧总说 由于机器人触发会比较慢 这边加一个500ms延时
        this.cancelSubmit()
        if (!res || res.code != 0) {
          this.$message({
            type: 'error',
            message: res.msg,
          });
          //判断标题唯一性是否正确
          this.$store.commit('upOnly', 'true');
        } else {
          this.addSuccess()
        }
      }).catch((err)=>{
        this.$message.error(err.msg)
      })
    },
    // 提交成功后的后续动作
    addSuccess () {

      // this.$message.success('提交成功')
        if (this.animationStyle && this.animationStyle.value && this.animationStyle.value === 2) {
          this.$message.success(this.animationStyle.animationList[2].text)
        }
        // 提交成功
        this.setMeter()
        // isDoorAdd 为 true 时可能是仪表盘打开提交的，返回一个特定回去触发刷新
        if (this.isDoorAdd) {
          this.$emit('doorUp')
        }
        this.setRefersh();
        if (this.addaction.val === 1 || this.addaction.val === 3) {
          if (this.dealFeildChange()) {
            this.$emit('inputClose');
          }else {
            this.subSuccss = true;
          }
          if (this.readcard.open) {
            this.closeReadcard = true
            this.readcard.open = false
          }
          // 提交成功 写入后执行动作为应用页面则延时1秒跳转（需求如此）
          if (this.addaction.val === 3) {
              if (this.addaction.datatype === 5) {
                window.open(`/clientSide/instrument/instrument?dataReportId=${this.addaction.appId}`, '_self')
              } else if (this.addaction.datatype === 1) {
                const obj = {
                  approvalId: this.addaction.appId,
                  iId: this.addaction.iId,
                  source: 'user',
                  name: this.addaction.appName
                }
                obj[goAppId[this.addaction.iId]] = this.addaction.iId
                window.open('/clientSide/application?' + qs.stringify(obj), '_self')
              }
          }
        } else if (this.addaction.val === 2) {
          this.refersh1()
        }else if (this.addaction.val === 4){
          this.$emit('inputClose');
        }
    },
    // 取消提交状态
    cancelSubmit () {
      this.isShowSucloading = false
      this.isSubmit = false
    },
    setTowSecond(second = 2000) {
      return new Promise((resolve) => {
        this.submitSuccessLoading = setTimeout(() => {
          resolve()
        }, second);
      })
    },
    async setTableScopeRow(submitValue) {
      if (this.insideAdd) {
        const customize = this.insideAdd.config.customize
        const from = this.insideAdd.config.from
        await this.setUpdateFeild({ li: from, type: 'from' }, submitValue)
        await this.setUpdateFeild({ li: customize, type: 'customize' }, submitValue)
      }
    },
    async setUpdateFeild(opt, submitValue) {
      const row = this.insideAdd.row
      const approvalId = this.insideAdd.approvalId
      const { li, type } = opt
      for (const ele of li) {
        const control = ele.FormList.find(f => f.name === ele.conditionValue)
        let value = null
        if (type === 'from') {
          value = submitValue[ele.source]
        } else {
          value = ele.value
        }
        const param = {
          approvalId,
          approvingId: row.approvingId,
          feild: control.fatherType,
          value
        }
        await updateapprovingbyfeild(param)
      }
    },
    // 仪表盘过来修改 or 提交的
    setMeter () {
      // 判断 url 只要带有 iId 并且为 12、13、14 就存一个参数
      const iId = this.$route.query.iId
      if (iId && (Number(iId) === 12 || Number(iId) === 13 || Number(iId) === 14)) {
        window.localStorage.setItem('meterId', true)
      }
    },
    //资助重复验证
    onFundingVerification(ruleFormAdd){
      this.fullScreenLoading = true;
      axiosBase(ruleFormAdd, "/openapi/fundingVerification").then(res => {
        if (!res) {
          this.$message({
            showClose: true,
            message: '学生资助名单重复申请验证请求失败',
            type: 'error'
          });
          return false
        }
        if (res.data&&res.data.data.length===0&&!res.data.msg) {
          //验证通过
          this.onAddapprovaling(ruleFormAdd)
        } else {
          //验证失败，提示
          const h = this.$createElement;
          let msg = res.data.msg ? res.data.msg : '您提交的“学生资助名单”中存在重复申请的学生，重复申请学生名单如下，请更正后提交（仅显示10名学生，超过部分将不在此处显示）'
          let msgboxcon = [
              h('p', null, msg),
            ]
          if (res.data.data.length > 0) {
            res.data.data.forEach((ele,ind) => {
              if (ind<10) {
                msgboxcon.push(h('p', { style: 'color: teal' }, '姓名：'+ele.studentName+'; 证件号码：' + ele.idcard))
              }
            });
          }
          this.$msgbox({
            title: '“学生资助名单”重复提示',
            message: h('div', null, msgboxcon),
            confirmButtonText: '确定',
          })
        }
        this.fullScreenLoading = false;
      });
    },
    // 设置弹窗尺寸
    setDiaSize (config) {
      let pdwidth
      let pdheight
      let isUsePx = false
      if (this.isFiexdCanvas) {
        const { height, width } = this.customInputConfig.configList[this.customCanvasIndex].fixedCanvasSize
        pdwidth = width.value
        if (width.type === 'custom') {
          isUsePx = true
        }
        pdheight = height.type
      } else {
        pdwidth = config.pdwidth
        pdheight = config.pdheight
      }
      this.$emit('upIsPcwidth', pdwidth || 75, isUsePx)
      // 弹窗加载完成调用
      this.$emit('loadSuccess')
      // pc弹窗高度设置
      if(pdheight){
        this.$emit('upIsPcHeight', pdheight)
        // 如果设置弹窗高度自适应，并且弹窗超出一屏，则设置弹窗高度为屏幕高度
        if(pdheight === 'auto'){
          setTimeout(() => {
            const wisdomSubmitEl = document.querySelector('.wisdomSubmit');
            if(!wisdomSubmitEl) return
            const wisdomSubmitHeight = wisdomSubmitEl.offsetHeight; // 获取.wisdomSubmit的高度
            const browserHeight = window.innerHeight; // 获取浏览器的高度
            // 如果.wisdomSubmit的高度超出浏览器高度，则修改其高度
            if (wisdomSubmitHeight > browserHeight) {
              wisdomSubmitEl.style.height = browserHeight-220 + 'px'; // 设置.wisdomSubmit的高度为浏览器高度
              if(this.aiStatus && this.aiIsOpen !== 0){
                // 获取右侧ai小易高度
                this.examineHeight = browserHeight-220
              }
            }
          }, 500);
        }
      }
    },
    //获取列表
    getsubmitformlist: function (type) {
      this.isOpenTheme = false
      // 弹窗一开始是不出来的
      // if (!type) this.isPop = false;

      //type这个是判断是iframe提交后更新数据
      let para = {
        approvalId: this.approvalId || this.$route.query.approvalId
      };
      let GetdataUrl = '/openapi/getapproval';
      // 如果是修改的话
      if (this.modifyId || this.modify) {
        GetdataUrl = '/api/getapproving';
        para.approvingId = this.$route.query.modifyId || this.modify && this.modify.modifyId ? this.modify.modifyId : ''
        para.person = this.$route.query.person || this.person
      }
      if (this.$route.query.fromset) {
        //如果是模板中心过来的预览模板
        //fromeset是模板中心过来的参数
        para = { approvalid: this.approvalId || this.$route.query.approvalId, pagesize: 1, curpage: 1 }
        GetdataUrl = '/api/getapprovaltpllist';
      }
      if (GetdataUrl === '/openapi/getapproval' && !(this.modifyId || this.modify)) {
        const fillquery = {}
        for (const ele of this.paramsList) {
          fillquery[ele.name] = { value: ele.value }
        }
        para.fillquery = fillquery
      }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        para.upaceid = upaceId
      }
      axiosBase(para, GetdataUrl).then(async (res) => {

        if (GetdataUrl === '/openapi/getapproval' && res.data.addconfig) {
          const addconfig = JSON.parse(res.data.addconfig)
          this.isSubmit = addconfig.isSubmit
          this.animationStyle = addconfig.animationStyle
          this.$emit('isSubmit', addconfig.isSubmit)
        }
        if (GetdataUrl === '/openapi/getapproval' && res.data.addbutton) {
          this.addbutton = JSON.parse(res.data.addbutton)
        }
        if (res.data.opensafe) this.opensafe = res.data.opensafe
        if (res.data && res.data.variableconfig) {
          const customData = JSON.parse(res.data.variableconfig)
          this.customData = await this.setParams({ customData: customData }, null, true)
        }
        let pageSet
        if (res.data && res.data.pageset) {
          try {
            this.isFiexdCanvas = false
            this.isHtml = false
            this.customCanvasIndex = 0
            this.customInputConfig = {}
            this.customInputAppInfo = {}
            pageSet = JSON.parse(res.data.pageset)
            if (pageSet && pageSet.url) {
              pageSet = await getConfigFromUrl(this.$url + pageSet.url)
              // 自定义提交页的配置
              if ((pageSet && pageSet[0].config[0] && pageSet[0].config[0].custom) && this.pageType !== 'default') {
                const obs = pageSet[0].config[0]
                if (obs.custom === 3 && obs.aiPage?.pageUrl) {
                  this.htmlInfo.url = `${this.$imgurl}/previewfiles/${obs.aiPage.pageUrl}?accesstoken=${this.user.accesstoken}`
                  this.isHtml = true
                }
                this.customInputConfig = JSON.parse(obs.content)
                this.isFiexdCanvas = this.customInputConfig.canvasType === 'fixedCanvas' ? true : false
                if (this.isFiexdCanvas) {
                  const isModify = this.modify ? true : false
                  let orders
                  if (isModify) {
                    const obj = {
                      curpage: 0,
                      pagesize: 0,
                      approvingId: this.modify.modifyId,
                      approvalId: this.approvalId
                    }
                    const { code, data } = await getuserapprovinglist(obj)
                    if (code === 0 && data && data[0] && data[0].approving) {
                      orders = data[0].approving.orders
                    }
                  }
                  this.customInputAppInfo = await getOtherAppConfig(this.customInputConfig, { isModify, orders })
                }
              }
               // 检测是否开启主题设计
              if (pageSet && pageSet.length > 2) {
                this.themeConfig = pageSet[2].pc
                this.isOpenTheme = true
              }
            }
          } catch (error) {
            console.log("详情页配置格式错误：", pageSet)
          }
        }
        console.log(pageSet, 'pageSet')
        if (res.data.linkconfig) {
          const linkconfig = JSON.parse(res.data.linkconfig)
          // this.$set(this, 'linkconfig', linkconfig)
          this.linkconfig = linkconfig
        }
        if (res.data.baseset) {
          this.baseSet = JSON.parse(res.data.baseset)
          if (this.baseSet.isAiInsert) {
            this.$refs.oaExamineInputRef.addEventListener('dragover', this.handleDragOver);
          }
          this.isCustomTitle = this.baseSet.isCustomTitle
          this.$emit('upBaseset', this.baseSet)
        }
        const robotConfig = (typeof res.data.robot == "string") ? JSON.parse(res.data.robot) : res.data.robot
        console.log("res.data.robot==",robotConfig);
        //如果开启了AI小易
        if (robotConfig && !Array.isArray(robotConfig)) {
          this.robotConfig = robotConfig
          this.aiIsOpen = robotConfig.fill.openai || 0
          this.$emit('upIsAi', robotConfig.fill.openai || 0)
        }
        this.setDiaSize(res.data)

				if(res.data.robot) {
          let robots = []
          try {
            robots = JSON.parse(res.data.robot)
          } catch (e) {
            robots.push(res.data.robot)
          }
          // this.$set(this, 'robots', robots)
          // this.$set(this, 'robot', robots[0])
          this.robots = robots
          this.robot = robots[0]
          // this.robots = JSON.parse(res.data.robot)
        }
        // 标题字体
        this.tipsize = res.data.tipsize || 14
        if (this.$route.query.fromset) {
          res.data = res.data[0]
        }
        this.flowshow = res.data.flowshow
        this.$emit('refFlowshow', res.data.flowshow)
        this.formButton = res.data.formButton
        this.iscustom = res.data.iscustom
        if (!res.data.property || res.data.property == '[]') {
          this.$message.error('表单未设计');
          this.$router.go(-1)
          return;
        }
        // 权限存储
        if (res.data.permissionlist) {
          let obj = {};
          let permissionlist = res.data.permissionlist || [];
          for (let i = 0; i < permissionlist.length; i++) {
            obj[permissionlist[i].key] = permissionlist[i].key;
          }
          this.permissionlistObj = obj;
        }
        // 如果有打开流程修改 并且 upfeild字段不为空数组  重新请求流程数组，并且进行流程处理
        if (this.modifyId || this.modify || this.$route.query.fromset) {
          if (res.data.upopen && res.data.upfeild && res.data.upfeild.length !== 0) {
            this.upopen = res.data.upopen
            this.upfeild = res.data.upfeild
            this.beforeFormdata = JSON.parse(res.data.formdata)
            delete this.beforeFormdata.approvalId
            delete this.beforeFormdata.linkedMessage
          }
        }
        // 后续动作配置
        if (res.data.addaction) {
          this.addaction = JSON.parse(res.data.addaction)
        }
        // 如果开启了读卡
        if (res.data.readcard) {
          const readcard = JSON.parse(res.data.readcard)
          // 开启了读卡，并且不是修改
          if (readcard.open) {
            // filesConfig
            readcard.addpic = readcard.addpic.indexOf('https://') !== -1 ? readcard.addpic : (this.$url + readcard.addpic + '?accesstoken=' + filesConfig())
            readcard.loadpic = readcard.loadpic.indexOf('https://') !== -1 ? readcard.loadpic : (this.$url + readcard.loadpic + '?accesstoken=' + filesConfig())
            this.readcard = readcard
          } else {
            // 提交后动作
            if (readcard.addpic) {
              this.readcard.addpic = readcard.addpic.indexOf('https://') !== -1 ? readcard.addpic : (this.$url + readcard.addpic + '?accesstoken=' + filesConfig())
            }
            if (readcard.addnotic) this.readcard.addnotic = readcard.addnotic
          }
        }
        //如果开启了扫码。并且不能跳过扫码，就提示他需要进入手机操作
        // if (res.data.scancode && !this.readcard.open) {
        //   this.fullScreenLoading = false;
        //   let scancode = (typeof res.data.scancode == "string") ? JSON.parse(res.data.scancode) : res.data.scancode
        //   if (scancode.scan && !scancode.continue && !this.modifyId && !this.modify) {//开启扫码，并且不允许跳过扫码,并且不是修改
        //     this.repeatdialog = { visible: true, keys: 2 };
        //     return false
        //   }
        // }
        //如果开启人脸识别
        if (res.data.faceinfo) {
          this.fullScreenLoading = false;
          let faceinfo = (typeof res.data.faceinfo == "string") ? JSON.parse(res.data.faceinfo) : res.data.faceinfo
          if(faceinfo.switch){
            this.toVeriQueryShow = true
            this.isShowfaceSet = true
            this.$emit('refFlowshow', 2)
            this.$emit('getfaceAr', faceinfo.mode === 'photo' ? 1 : 2)
            nextTick(() => {
              let property = JSON.parse(res.data.property);
              console.log("property==",property)
              this.$refs.faceSetRef.onFormeParent(property, faceinfo)
            })
            // this.faceConfig = faceinfo
          }
        }
        else{
          // 关闭ar按钮
          this.$emit('getfaceAr', 0)
        }
        //如果开启了OCR设置
        if (res.data.ocrinfo) {
          this.fullScreenLoading = false;
          let ocrinfo = (typeof res.data.ocrinfo == "string") ? JSON.parse(res.data.ocrinfo) : res.data.ocrinfo
          if(ocrinfo.switch){
            this.toVeriQueryShow = true
            this.isShowocrSet = true
            nextTick(() => {
              this.$refs.ocrSetRef.onFormeParent(ocrinfo)
            })
            this.ocrConfig = ocrinfo
          }
        }
        // 如果有两列 or 四列布局 layout
        if (res.data.layout) this.layout = res.data.layout;
        if (type && type == 1) {
          parent.vueFun(res.data.approvalId, res.data.repeat);
        }
        if (this.iscustom == 1 && this.isCustomTitle !== false) {
          this.appname = res.data.title || ""
        }
        // 存一下权限，用来返回去上一级判断有没有未填提醒的
        if (res.data.repeat) this.repeat = res.data.repeat;
        let iagreeKey = JSON.parse(res.data.iagree || '{}')
        if (iagreeKey.agreeSwitch&&iagreeKey.showType===0) { // 如果有二次确认框字段，需要进去判断是否有开启
          // this.$set(iagreeKey,'Visible',true)
          iagreeKey.Visible = true
        }
        this.iAgreePargam = iagreeKey
        const repeat = res.data.repeat;
        if (repeat && repeat.repeat && !type) {
          if (res.data.repeat.num === 1) {
            const power = await getopenreportformlist({ curpage: 0, pagesize: 0, approvalId: this.approvalId || this.$route.query.approvalId })
            let _power = {}
            if (power.code === 0) {
              _power = power.data.find(f=> f.userId)
            }
            const param = {
              approving: {
                approvingId: repeat.approvingId,
                approvalId: this.approvalId || this.$route.query.approvalId,
              },
              userapprovingId: repeat.userapprovingId,
              approvalId: this.approvalId || this.$route.query.approvalId,
              "delete": _power.delete,
              "update": _power.update
            }
            this.isAppenPage = 'details'
            nextTick(() => {
              setTimeout(() => {
                this.openDetail(param)
              }, 100);
            })
          } else {
            this.repeatdialog = { visible: true, keys: 1 }
            this.isAppenPage = 'add'
          }
          this.fullScreenLoading = false;
          //以下本来是作为提示得，后面改成页面，后续需要改成提示，只要把后面注释去掉即可
          // this.repeatObjSudIs = true;
          // this.repeatObj = res.data.repeat;
          // const repeatO = this.repeatObj;
          //提示语开始
          // const dateArr = repeatO.start+"-"+repeatO.end;
          // let textMess = dateArr+'本阶段只能提交'+repeatO.num+'次，您已达到上限。'+repeatO.end+'可再次开始填报。';
          //提示语结束
          // this.$alert(textMess, '周期填写提示', {
          //   confirmButtonText: '我知道了',
          //   confirmButtonClass:'confirm-class'
          // });
        } else {
          this.isAppenPage = 'add'
          if (res.data.install) {//是否有验证规则
            let install = JSON.parse(res.data.install)
            if (install.addCheckNameUnique) this.tipsIs = install.addCheckNameUnique.tipsIs;
          }
          // 是否存在暂存值
          if (this.$route.query.approvingId || this.approvingId) {
            //如果是重新提交
            const objs = {
              curpage: 0,
              pagesize: 0,
              approvingId: this.$route.query.approvingId || this.approvingId
            }
            // 从空间进入，需要传空间id
            if(this.isSpace){
              const spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
              objs.spaceid = spaceId;
            }
            else if (this.isUpace) {
              let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
              objs.upaceid = upaceId
            }
            if (this.approvalId || this.$route.query.approvalId) objs.approvalId = this.approvalId || this.$route.query.approvalId
            axiosBase(objs, "/openapi/getuserapprovinglist").then(back => {
              if (back.data[0].title) {
                this.appname = back.data[0].title
              }
              try {
                this.formlistprocessmethods(res, JSON.parse(back.data[0].approving.formdata))
              }
              catch (e) { console.log('重新提交这里错了', e, back.data[0].approving.formdata) }
            });
          } else {
            if (res.data.cash) {
              this.fullScreenLoading = false
              this.$confirm('草稿箱中有暂存数据，是否读取?', '提示', {
                closeOnClickModal: false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.formlistprocessmethods(res, JSON.parse(res.data.cashdata))
              }).catch(() => {
                this.formlistprocessmethods(res, res.data.formdata ? JSON.parse(res.data.formdata) : undefined)
              });
            } else {
              this.formlistprocessmethods(res, res.data.formdata ? JSON.parse(res.data.formdata) : undefined)
            }
          }
        }
        // 如果是修改，查询当前是否有预约控件，有的话用预约时间去查询已预约数据
        if (this.modify) {
          setTimeout(() => {
            this.$refs.widgetOneLayerRef.openGetWidgetVal()
          }, 0)
          // nextTick(() => {
          //   this.$refs.widgetOneLayerRef.openGetWidgetVal()
          // })
        } else {
          this.isInquire()
        }
      }).catch(error => {
        console.log('getapproval 接口出错1', error)
      });
    },
    async formlistprocessmethods (res, data) {
      let install = res.data.install ? JSON.parse(res.data.install) : '';
      // 结果集的字典结构
      let property = JSON.parse(res.data.property)
      this.appProperty = JSON.parse(res.data.property)
      if (this.isFiexdCanvas) {
        property = dealInputConfig(this.customInputConfig.configList[this.customCanvasIndex], cloneDeep(property))
      }
      let formdata = momVal(property, '', this.customData);
      if (this.linkconfig.open && (this.linkconfig.link || this.linkconfig.terrace)) {
        formdata.linktype = this.linkconfig.terrace ? '0' : '1'
      }
      if (this.vfandqFormdata) {
        data = Object.assign(data ? data : { daliu: 1 }, this.vfandqFormdata)
      }
      // 有值赋值
      if (data) {
        // 这个是初始化和赋值的方法
        formdata = assignFormdata(formdata, data);
        if (!data.daliu || this.$route.query.approvingId || this.approvingId) {//有数据，如果是记取，就联动
          this.isInput = 2
        }
      }
      // 这里做传值进来赋值
      if (this.coverVal && typeof this.coverVal === 'object') {
        try {
          for (const i in this.coverVal) {
            // 判断是否明细
            if (i.includes('details') && i.split('.').length !== 1) {
              const its = i.split('.')
              formdata[its[0]][0][its[1]] = this.coverVal[i]
            } else if (i.includes('ready-widget')) {
              // 判断是否为预约控件
              const obj = this.coverVal[i]
              for (const idx in formdata[i]) {
                formdata[i][idx] = {
                  ...formdata[i][idx],
                  ...obj[idx]
                }
              }
            } else if (i.includes('date')) {
              if (Array.isArray(this.coverVal[i])) {
                formdata[i] = this.coverVal[i][0]
              } else {
                formdata[i] = this.coverVal[i]
              }
            } else {
              // 不是明细直接赋值
              formdata[i] = this.coverVal[i]
              if (this.isFiexdCanvas) {
                const [title, type] = i.split('_')
                const obj = { title, type }
                this.updateOtherAppData(obj, this.coverVal[i])
              }
            }
          }
        } catch (e) {
          console.log('船只问题错误', e)
        }
      }
      if (!((this.modifyId || this.modify || this.$route.query.fromset))) {
        // 编辑的时候不走控件的绑定字段，欧总那边报了bug 所以不走
        formdata = await defaultValuesForParameterTransmission(property, formdata)
      }
      // 这里做暂存结构修改(因为要等formdata进行过一次赋值所以放这里)
      let upFormdata = setOthersFormdata(property, formdata, install);
      this.associationVisible = upFormdata.associationVisible;
      this.isNameCto = upFormdata.isNameCto;
      // 赋值模板
      if (this.isReadonlyDetails) {
        for (const ele of upFormdata.template) {
          if (ele.type !== 'details') {
            ele.viewHide = true
          }
        }
      }
      this.ruleList = upFormdata.template
      this.cutObj = upFormdata.cutObj
      if (data) {
        formdata = upFormdata.formdata;
        this.othersObj = upFormdata.othersObj;
      }
      let approvingFormdata = {}
      if (this.modifyId || this.modify) {
        approvingFormdata = JSON.parse(res.data.formdata)
      }
      this.customInputAppInfo[res.data.approvalId] = {
        formdata,
        property: JSON.parse(res.data.property)
      }
      // 明细数据兼容小程序bug
      try {
        for(let key in formdata) {
          if (key.search('details')!== -1) {
            // 明细控件-增加是否填写开关
            const prefix = key.split('_details')[0];
            const fillStatusKey = prefix + '_fillStatus';
            if (!Object.prototype.hasOwnProperty.call(formdata, fillStatusKey)) {
              console.log("approvingFormdata[fillStatusKey]==",approvingFormdata[fillStatusKey])
              if (approvingFormdata && Object.prototype.hasOwnProperty.call(approvingFormdata, fillStatusKey)) {
                formdata[fillStatusKey] = approvingFormdata[fillStatusKey];
              } else {
                formdata[fillStatusKey] = 1;
              }
            }
            formdata[key].forEach(item=>{
              for(let _key in item) {
                if (_key.search('relation-user')!== -1 || _key.search('radio')!== -1) {
                  if (item[_key]) {
                    item[_key] = item[_key].value ? item[_key].value : item[_key]
                  }
                  if (_key.search('relation-user') !== -1) {
                    console.log(typeof item[_key] == 'string','item[_key]',item[_key]);
                    item[_key] = typeof item[_key] == 'string' && item[_key] !== ''  ? JSON.parse(item[_key]) : item[_key]
                  }
                }
              }
            })
          }
        }
      } catch(e) {
        console.log('明细数据兼容小程序bug', e)
      }
      this.formdata = formdata;
      if (this.isHtml) {
        this.$nextTick(()=>{
          this.sendModeConfig('edit', this.formdata)
        })
      }
      this.fullScreenLoading = false;
      //- 修改模式不走流程
      if ((this.modifyId || this.modify || this.$route.query.fromset)) {
        if (this.upopen === 0 && this.upfeild && this.upfeild.length === 0) {
          return false;
        }
      }
      //联动初始化
      if (!this.modifyId && !this.modify) {
        setTimeout(() => { if (this.$refs.widgetOneLayerRef && this.$refs.widgetOneLayerRef.linkageInitiali) this.$refs.widgetOneLayerRef.linkageInitiali(-1) }, 500)
      }
      this.ongetapprovaluser(res);
    },
    //初始化审批流程
    ongetapprovaluser (res) {
      let obj = { approvalId: res.data.approvalId }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      axiosBase(obj, "/openapi/getapprovaluser").then(ret => {
        if (!ret.data.to || !ret.data.workflow || ret.data.to.length == 0 && ret.data.workflow.length == 0) {
          this.$message({ message: '审批流程未设置请联系管理员设置审批流程', type: 'warning' });
          return;
        }
        if (ret.data.to.length > 0) {
          ret.data.to.forEach(e => {
            if (e.orgname) {//
              if (e.user.length > 0) {
                e.user.forEach(l => {
                  if (l.type == 2 && l.freestyle != 0 || l.type == 3 && l.freestyle != 0) {
                    l.user1 = JSON.parse(JSON.stringify(l.user))
                    l.user = [];
                  }
                })
              }
            } else {
              if (e.type == 2 && e.freestyle != 0 || e.type == 3 && e.freestyle != 0) {
                e.user1 = JSON.parse(JSON.stringify(e.user))
                e.user = [];
              }
            }
          });
        }
        if (ret.data.workflow.length > 0) {
          ret.data.workflow.forEach(e => {
            if (e instanceof Array) {//需要选择部门
              e.forEach(l => {
                l.user.forEach(m => {
                  if (m.type == 2 && m.freestyle != 0 || m.type == 3 && m.freestyle != 0) {
                    m.user1 = JSON.parse(JSON.stringify(m.user))
                    m.user = [];
                  }
                });
              })
            } else {
              e.user.forEach(l => {
                if (l.type == 2 && l.freestyle != 0 || l.type == 3 && l.freestyle != 0) {
                  l.user1 = JSON.parse(JSON.stringify(l.user))
                  l.user = [];
                }
              })
            }
          });
        }
        this.ctoArray = JSON.parse(JSON.stringify(ret.data));
        if (ret.data.install.departdistinct && ret.data.install.departdistinct == 1) {//去重
          this.ctoArrayDdt = JSON.parse(JSON.stringify(ret.data));
          if (ret.data.to.length > 0) {
            this.changeOrgname(ret.data.to[0].orgname);
          } else if (ret.data.workflow.length > 0) {
            ret.data.workflow[0].forEach(e => {
              this.ctoArrayDdt.to.push({ orgname: e.orgname, user: [] })
            });
            this.changeOrgname(this.ctoArrayDdt.to[0].orgname);
          }
        }
        this.approvalProcess()
        // 暂存保存数据。备用明细新增清除数据
      }).catch(error => {
        console.log('getapprovaluser 接口出错', error)
      });
    },
    //流程初始化
    approvalProcess () {
      if (!this.ctoArray) {
        return
      }
      if (this.ctoArray.workflow != undefined && this.ctoArray.workflow != null && this.ctoArray.workflow.length > 0) {//如果有workflow
        let yesIndexOfOver = false;
        this.ctoArray.workflow.forEach((el1, key) => {
          if (!yesIndexOfOver) {//如果循环结束==false
            let yesIndexOf = true;//是否包含==包含
            let workLenth = el1.workflow.length;//条件长度
            el1.workflow.forEach(el2 => {
              this.ruleList.forEach(el3 => {//循环内容
                if (el3.title == el2.title) {//如果workflow里面的title==内容的title
                  const IsWork = this.conditionFun(el2, this.formdata[el3.title + '_' + el3.type]); // 第二个参数是值
                  //满足一个条件减一知道为0都满足
                  if (IsWork) {
                    workLenth -= 1;
                  }
                  //为0是都满足长度
                  if (workLenth == 0) {
                    yesIndexOf = true;
                  } else {
                    yesIndexOf = false;
                  }
                }
                if (el3.type == 'relation-radio' || el3.type == 'ready-widget') {
                  let type = el3.title + '_' + el3.type;

                  if (this.formdata[type] && this.formdata[type].length > 0) {
                    let formdatas = this.formdata[type];
                    for (let i = 0; i < formdatas.length; i++) {
                      el3.list.forEach((relList) => {
                        if ((el3.title + '-' + relList.title) == el2.title) {
                          const IsWork = this.conditionFun(el2, formdatas[i][relList.title + '_' + relList.type]);
                          //满足一个条件减一知道为0都满足
                          if (IsWork) {
                            workLenth -= 1;
                          }
                          //为0是都满足长度
                          if (workLenth == 0) {
                            yesIndexOf = true;
                          } else {
                            yesIndexOf = false;
                          }
                        }
                      })
                    }
                  }
                }
                // 配置关联单选，导致流程人员没显示，不知道以前为什么是用上面方法写，所以现在单独处理（25.9.8 hj）
                else if(el3.type == 'new-rel-radio'){
                  let type = el3.title + '_' + el3.type;
                  if (this.formdata[type]) {
                    let formdatas = this.formdata;
                    el3.list.forEach((relList) => {
                      if ((el3.title + '-' + relList.title) == el2.title) {
                        const IsWork = this.conditionFun(el2, formdatas[relList.title + '_' + relList.type]);
                        //满足一个条件减一知道为0都满足
                        if (IsWork) {
                          workLenth -= 1;
                        }
                        //为0是都满足长度
                        if (workLenth == 0) {
                          yesIndexOf = true;
                        } else {
                          yesIndexOf = false;
                        }
                      }
                    })
                  }
                }
              });
            })
            if (yesIndexOf) {//如果走完上面的还是包含，那就
              yesIndexOfOver = true;
              this.APKey = key;
            } else {
              this.APKey = -1;
            }
          }
        });
      } else {
        this.APKey = -1
      }
      //这里处理当联系人同步审批流程的时候，下面这个方法有用
      if (this.APKey < 0) {
        this.ctoArray.to.forEach(items => {
          if (items.type == 7 && items.controller) {
            //这里需要判断是否明细
            if (items.controller.length > 20) {
              let conter = items.controller.split(".");
              items.user = this.detailsObjArrFun(this.formdata[conter[0] + '_details'], conter[1] + '_relation-user');
            } else {
              items.user = copyObj(this.formdata[items.controller + '_relation-user'] || []);
            }
          }
        })
      } else {
        this.ctoArray.workflow[this.APKey].user.forEach(items => {
          if (items.type == 7 && items.controller) {
            //这里需要判断是否明细
            if (items.controller.length > 20) {
              let conter = items.controller.split(".");
              items.user = this.detailsObjArrFun(this.formdata[conter[0] + '_details'], conter[1] + '_relation-user');
            } else {
              items.user = copyObj(this.formdata[items.controller + '_relation-user'] || []);
            }
          }
        })
      }
      //告知Dom显示
      if (this.ctoArray.cto.length > 0) {
        // this.isCtoShow = true;
      }
    },
    // 正对明细的扁平化
    detailsObjArrFun (val, title) {
      if (!Array.isArray(val) || !val || val.length === 0) return [];
      let arr = [];
      val.forEach(item => {
        if (item[title]) {
          arr = arr.concat(item[title]);
        }
      });
      console.log('返回', arr)
      return unique(arr, 'userId');
    },
    //条件判断
    conditionFun (param2, param3) {
      let yesIndexOf = true;
      if (param2.type == "radio") {
        if (param2.sels.length > 0 && (param2.sels).indexOf(param3) < 0) {
          // if (param2.sels.length > 0 && (param2.sels).indexOf(param3.bindinf) < 0) {
          yesIndexOf = false
        }
      } else if (param2.type == "number") {
        if (param2.range == "小于") {
          if (param3 && param2.min && Number(param3) >= Number(param2.min)) {
            yesIndexOf = false
          }
        } else if (param2.range == "小于等于") {
          if (param3 && param2.min && Number(param3) > Number(param2.min)) {
            yesIndexOf = false
          }
        } else if (param2.range == "大于") {
          if (param3 && param2.min && Number(param3) <= Number(param2.min)) {
            yesIndexOf = false
          }
        } else if (param2.range == "大于等于") {
          if (param3 && param2.min && Number(param3) < Number(param2.min)) {
            yesIndexOf = false
          }
        } else if (param2.range == "等于") {
          if (param3 != param2.min) {
            yesIndexOf = false
          }
        } else if (param2.range.indexOf("介于") >= 0) {
          if (param3 < param2.min || param3 > param2.max) {
            yesIndexOf = false
          }
        }
      }
      return yesIndexOf;
    },
    toAdd (item, key) {
      if (item.errorMsg) {
        delete item.errorMsg
      }
      console.log("toAdd==",item, key);
      this.type5 = item
      this.toKey = 0;
      var param = {
        showBatch: true
      }
      if (item.user && item.user.length > 0) {
        param.checkedUserArr = []
        item.user.forEach(e => {
          param.checkedUserArr.push({ userId: e.userId, realname: e.name })
        });
      }
      if (item.organizationidArr) {
        param.checkedFlowArr = item.organizationidArr
      }
      if (item.roleidArr) {
        param.checkedRoleArr = item.roleidArr
      }
      //调用子组建的方法
      param.isapiurl = '/openapi';
      this.$refs.multipleChoiceChild.multipleChoiceMethod(param);
    },
    showCtoList(){
      let searchParam = {};
      // 判断是否有配置告知范围
      if(Object.prototype.hasOwnProperty.call(this.ctoArray.install, 'depts') && this.ctoArray.install.depts.length > 0){
        const freeList = this.ctoArray.install.depts;
        let roleArr = [];
        let flowArr = [];
        freeList.forEach(e => {
          if(e.roleId){//角色
            roleArr.push({roleId:e.roleId,name:e.name||e.realname})
          }else{//组织
            flowArr.push({organizationId:e.organizationId,name:e.name||e.realname})
          }
        });
        searchParam.lookCustomArr = JSON.stringify(flowArr);
        searchParam.lookCustomArrRole = JSON.stringify(roleArr);

        this.$refs.linkedDropDownRef.getNewList(searchParam, {channel: 'cto'});
      }
      else{
        this.$refs.linkedDropDownRef.getNewList(searchParam, {channel: 'ctoAll'});
      }
    },
    // 通知对象精确搜索
    ctoSearchKey(){
      console.log('搜索关键字', this.searchKey)
      // if (this.searchKey == '') return this.$message.warning('请输入您要搜索的人员！')
      let searchParam = {};
      // const obj = {
      //   curpage: 1,
      //   pagesize: 100,
      //   name: this.searchKey
      // }
      // 判断是否有配置告知范围
      if(Object.prototype.hasOwnProperty.call(this.ctoArray.install, 'depts') && this.ctoArray.install.depts.length > 0){
        const freeList = this.ctoArray.install.depts;
        let roleArr = [];
        let flowArr = [];
        freeList.forEach(e => {
          if(e.roleId){//角色
            roleArr.push({roleId:e.roleId,name:e.name||e.realname})
          }else{//组织
            flowArr.push({organizationId:e.organizationId,name:e.name||e.realname})
          }
        });
        searchParam.lookCustomArr = flowArr;
        searchParam.lookCustomArrRole = roleArr;
        this.$refs.linkedDropDownRef.getNewList(searchParam, {channel: 'cto'}, '', this.searchKey);
      }
      else{
        this.$refs.linkedDropDownRef.getNewList(searchParam, {channel: 'ctoAll'}, '', this.searchKey);
      }
    },
    //联系人控件批量查找
    showBatchSearch(){
      let searchParam = {};
      // 判断是否有配置告知范围
      if(Object.prototype.hasOwnProperty.call(this.ctoArray.install, 'depts') && this.ctoArray.install.depts.length > 0){
        const freeList = this.ctoArray.install.depts;
        let roleArr = [];
        let flowArr = [];
        freeList.forEach(e => {
          if(e.roleId){//角色
            roleArr.push({roleId:e.roleId,name:e.name||e.realname})
          }else{//组织
            flowArr.push({organizationId:e.organizationId,name:e.name||e.realname})
          }
        });
        searchParam.lookCustomArr = JSON.stringify(flowArr);
        searchParam.lookCustomArrRole = JSON.stringify(roleArr);
        this.$refs.batchSearchRef.fromParentMethod(searchParam, '', 'cto');
      }
      else{
        this.$refs.batchSearchRef.fromParentMethod(searchParam, '');
      }
    },
    handleBatchSearchChild(param){
      console.log("param==",param)
      // 搜索用户时，如果存在之前的用户数据，需要把之前的用户数据也带过来
      const userIdsInArr1 = new Set(this.checkedArrUser.map(item => item.userId));
      const userArrList = this.checkedArrUser.concat(
        param.user.filter(item => !userIdsInArr1.has(item.userId))
      );
      const obj = {
        checkedUserArr: userArrList
      }
      this.toKey = 1;
      this.fromMultipleChoice(obj);
      this.searchKey = ''
    },
    ctoAdd () {
      this.toKey = 1;
      //- 获取告知流程之前是否存在提交数据
      let param = {
        checkedFlowArr: [],//- 组织
        checkedUserArr: [],//- 用户
        checkedRoleArr: [],//- 角色
        checkedGroupArr: [],//- 分组
      };
      let checkedFlowArr = [];//- 组织
      let checkedUserArr = [];//- 用户
      let checkedRoleArr = [];//- 角色
      let checkedGroupArr = [];//- 分组
      if (this.APKey == -1) {
        this.ctoArray.cto.forEach((item) => {
          if (item.delete && item.delete === true) {
            if (item.userId) {//- 用户
              checkedUserArr.push({
                realname: item.realname || item.name,
                userId: item.userId,
                orgname: item.orgname
              });
            } else if (item.organizationId) {//- 组织
              checkedFlowArr.push({
                name: item.realname || item.name,
                organizationId: item.organizationId
              });
            } else if (item.roleId) {//角色
              checkedRoleArr.push({
                roleId: item.roleId,
                name: item.name || item.realname
              })
            }
          } else {
            if (item.folderId) {//分组
              const index = checkedGroupArr.findIndex(iten => { return iten.id === item.folderId } )
              if (index === -1) {
                checkedGroupArr.push({
                  id: item.folderId,
                  name: item.realname
                })
              }
            }
          }
        })
      } else {
        this.ctoArray.workflow[this.APKey].cto.forEach((item) => {
          if (item.delete && item.delete === true) {
            if (item.userId) {//- 用户
              checkedUserArr.push({
                realname: item.realname || item.name,
                userId: item.userId,
                orgname: item.orgname
              });
            } else if (item.organizationId) {//- 组织
              checkedFlowArr.push({
                name: item.realname || item.name,
                organizationId: item.organizationId
              });
            } else if (item.roleId) {//角色
              checkedRoleArr.push({
                roleId: item.roleId,
                name: item.name || item.realname
              })
            }
          } else {
            if (item.folderId) {//分组
              const index = checkedGroupArr.findIndex(iten => { return iten.id === item.folderId } )
              if (index === -1) {
                checkedGroupArr.push({
                  id: item.folderId,
                  name: item.realname
                })
              }
            }
          }
        })
      }
      param.checkedFlowArr = JSON.parse(JSON.stringify(checkedFlowArr));
      param.checkedUserArr = JSON.parse(JSON.stringify(checkedUserArr));
      param.checkedRoleArr = JSON.parse(JSON.stringify(checkedRoleArr));
      param.checkedGroupArr = JSON.parse(JSON.stringify(checkedGroupArr));
      //调用子组建的方法
      param.isapiurl = '/openapi';
      param.isGroup = true;
      param.grouping = this.baseSet.grouping;
      param.approvalId = this.approvalId;
      param.showBatch = true;
      param.channelFrom = 'cto';
      // 判断是否有配置告知范围
      if(Object.prototype.hasOwnProperty.call(this.ctoArray.install, 'depts') && this.ctoArray.install.depts.length > 0){
        const freeList = this.ctoArray.install.depts;
        let roleArr = [];
        let flowArr = [];
        freeList.forEach(e => {
          if(e.roleId){//角色
            roleArr.push({roleId:e.roleId,name:e.name||e.realname})
          }else{//组织
            flowArr.push({organizationId:e.organizationId,name:e.name||e.realname})
          }
        });
        param.lookCustomArr = flowArr;
        param.lookCustomArrRole = roleArr;
        param.lookRMSIsUser = 4;
      }
      this.$refs.multipleChoiceChild.multipleChoiceMethod(param, param);
    },
    delMeth (item, key, key1) {
      if (item[key].user.length > 1) {
        item[key].user.splice(key1, 1)
      } else {
        if (item[key].roleids || item[key].organizationids) {
          item[key].user.splice(key1, 1)
        } else {
          if (item[key].type === 5) {
            item[key].user.splice(key1, 1);
          } else {
            item.splice(key, 1);
          }
        }
      }
    },
    delOrg (item, key, key1) {
      if (item[key].organizationids.length > 1) {
        item[key].organizationidArr.splice(key1, 1)
        item[key].organizationids.splice(key1, 1)
      } else {
        if (item[key].roleids || item[key].user) {
          item[key].organizationidArr.splice(key1, 1)
          item[key].organizationids.splice(key1, 1)
        } else {
          item.splice(key, 1)
        }
      }
    },
    delRole (item, key, key1) {
      if (item[key].roleids.length > 1) {
        item[key].roleidArr.splice(key1, 1)
        item[key].roleids.splice(key1, 1)
      } else {
        if (item[key].organizationids || item[key].user) {
          item[key].roleidArr.splice(key1, 1)
          item[key].roleids.splice(key1, 1)
        } else {
          item.splice(key, 1)
        }
      }
    },
    delCto (item, key) {
      item.splice(key, 1)
    },
    fromMultipleChoice (param) {//来源multipleChoice.vue的方法
      let list = {};
      if (param.checkedFlowArr) {
        list.organizationidArr = param.checkedFlowArr
        this.checkedFlowArr = param.checkedFlowArr
        list.organizationids = []
        param.checkedFlowArr.forEach(element => {
          list.organizationids.push(element.organizationId)
        });
      }
      if (param.checkedRoleArr) {
        list.roleids = []
        param.checkedRoleArr.forEach(el => {//过滤掉el.listpermission。看着烦。一坨的不知数据
          list.roleids.push(el.roleId)
          if (el.listpermission) {
            delete el.listpermission
          }
        });
        list.roleidArr = param.checkedRoleArr
        this.checkedRoleArr = param.checkedRoleArr
      }
      if (param.checkedUserArr) {
        var userArrList = [];
        // 搜索用户时，如果存在之前的用户数据，需要把之前的用户数据也带过来
        param.checkedUserArr.forEach(el => {
          userArrList.push({ name: el.realname || el.name, userId: el.userId, orgname: el.orgname })
        });
        list.user = userArrList;
        this.checkedArrUser = userArrList
      }
      if (param.checkedGroupArr) {
        var groupArrList = [];
        param.checkedGroupArr.forEach(el => {
          groupArrList.push({ realname: el.name, folderId: el.id })
        });
        this.checkedArrGroup = groupArrList
      }
      if (this.toKey == 0) {//如果为0 就是审批流程
        if (list.organizationidArr) {
          // this.$set(this.type5, 'organizationidArr', list.organizationidArr)
          this.type5.organizationidArr = list.organizationidArr
          this.type5.organizationids = list.organizationids
        }
        if (list.roleidArr) {
          // this.$set(this.type5, 'roleidArr', list.roleidArr)
          this.type5.roleidArr = list.roleidArr
          this.type5.roleids = list.roleids
        }
        if (list.user) {
          this.type5.user = list.user
        }
      } else {//否则就是告知流程
        let bei_data = [];//- 备份数据
        //- 先删除之前的数据
        if (this.APKey == -1) {
          this.ctoArray.cto.forEach((item) => {
            if (!item.delete && !item.folderId) {
              bei_data.push(item)

            }
          })
          this.ctoArray.cto = JSON.parse(JSON.stringify(bei_data));
        } else {
          this.ctoArray.workflow[this.APKey].cto.forEach((item) => {
            if (!item.delete && !item.folderId) {
              bei_data.push(item)

            }
          })
          this.ctoArray.workflow[this.APKey].cto = JSON.parse(JSON.stringify(bei_data));
        }
        if (param.checkedFlowArr) {
          for (var e = 0; e < param.checkedFlowArr.length; e++) {
            if (this.APKey == -1) {
              this.ctoArray.cto.push({
                realname: param.checkedFlowArr[e].name,
                organizationId: param.checkedFlowArr[e].organizationId,
                delete: true
              });
            } else {
              this.ctoArray.workflow[this.APKey].cto.push({
                realname: param.checkedFlowArr[e].name,
                organizationId: param.checkedFlowArr[e].organizationId,
                delete: true
              });
            }
          }
        }
        if (param.checkedRoleArr) {
          for (let e = 0; e < param.checkedRoleArr.length; e++) {
            if (this.APKey == -1) {
              this.ctoArray.cto.push({
                realname: param.checkedRoleArr[e].name,
                roleId: param.checkedRoleArr[e].roleId,
                delete: true
              });
            } else {
              this.ctoArray.workflow[this.APKey].cto.push({
                realname: param.checkedRoleArr[e].name,
                roleId: param.checkedRoleArr[e].roleId,
                delete: true
              });
            }
          }
        }
        if (param.checkedUserArr) {
          for (let e = 0; e < param.checkedUserArr.length; e++) {
            if (this.APKey == -1) {
              this.ctoArray.cto.push({
                realname: param.checkedUserArr[e].realname || param.checkedUserArr[e].name,
                userId: param.checkedUserArr[e].userId,
                orgname: param.checkedUserArr[e].orgname,
                delete: true
              });
            } else {
              this.ctoArray.workflow[this.APKey].cto.push({
                realname: param.checkedUserArr[e].realname || param.checkedUserArr[e].name,
                userId: param.checkedUserArr[e].userId,
                orgname: param.checkedUserArr[e].orgname,
                delete: true
              });
            }
          }
        }
        if (param.checkedGroupArr) {
          for (let e = 0; e < param.checkedGroupArr.length; e++) {
            const item = param.checkedGroupArr[e]
            if (this.APKey == -1) {
              this.ctoArray.cto.push({
                realname: item.name,
                folderId: item.id,
              });
            } else {
              this.ctoArray.workflow[this.APKey].cto.push({
                realname: item.name,
                folderId: item.id,
              });
            }
          }
        }
      }
    },
    changeUser (item) {
      if (item.errorMsg) {
        delete item.errorMsg
      }
      var radioUser = false;
      if (item.freestyle == 1) {
        radioUser = true;
      }
      this.itemKey = item
      this.$refs.levelSelectRef.levelSelectChild({
        checkedList: item.user1,
        checkedFlow: item.user,
        radioUser: radioUser
      });
    },
    levelSelectMethod (param) {//自由选择返回
      this.itemKey.user = param
    },
    oaExamineAssFormMethod () {//关联表单选择返回

    },
    widgetOneLayerEmitFun (res) {
      //res.type=1== 1是流程分条件第一层。4图片附件上传状态如上传完成与否,6是批量连联动加载表现linkageLoading使用，
      if (res.type == 4) {
        this.upDataFileState = res;
      } else if (res.type == 6) {
        this.linkageLoading = res.linkageLoading
      } else {
        this.approvalProcess();
      }
    },
    //来源于验证得方法
    formVerificationAndQuery (data) {
      this.vfandqFormdata = data && data.dataList ? data.dataList : null;
      this.toVeriQueryShow = false;
      this.getsubmitformlist();
    },
    //- 判断当前场景
    judgeScene () {
      if (this.modifyId || this.modify) {
        //- 修改数据模式
        this.getsubmitformlist();
        // this.fullScreenLoading = true;
      } else {
        //- 正常填写模式需要判断是否需要展开验证数据
        this.whetherShow(0)
      }

    },
    sendModeConfig(mode, data = null) {
        const message = {
            type: 'MODE_CONFIG',
            mode: mode, // 'edit' 或 'view'
        };
        if (mode === 'edit' && data) {
            message.data = JSON.parse(JSON.stringify(data));
        }
        const ref = this.$refs.htmlIframe
        // 确保iframe加载完成后发送 (此处直接发送，若iframe未完全加载，消息也会被缓存；稳妥起见加一个简单延时)
        if (ref && ref.contentWindow) {
          ref.contentWindow.postMessage(message, '*');
        }
    },
    //- 表单·获取列表
    whetherShow (type) {
      //type这个是判断是iframe提交后更新数据
      let para = {
        approvalId: this.approvalId || this.$route.query.approvalId,
        number: type,
      };
      let url="";
      try {
          url = window.top.document.referrer ;
      } catch(M) {
          if (window.parent) {
            try {
              url = window.parent.document.referrer;
            } catch(L) {
              url = "";
            }
          }
      }
      if (url === "") {
          url = document.referrer;
      }
      // 如果是从模板中心访问，则不需要请求验证接口
      if(url.includes('templateCorelist')){
        this.formVerificationAndQuery();
        this.fromTemplate = true;
      }
      else{
        // 从空间进入，需要传空间id
        if(this.isSpace){
          const spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
          para.spaceid = spaceId;
        }
        else if (this.isUpace) {
          let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
          para.upaceid = upaceId
        }
        console.log(para,'paraparaparapara');
        getvalidateapproval(para).then(res => {
          if ( res.data.property && res.data.property.length>0) {
            this.toVeriQueryShow = true;
            nextTick(() => {
              this.$refs.VerificationAndQueryInputRef.showList(res);
              this.$emit('loadSuccess')
            })
          } else {
            //- 说明不需要开启验证
            this.formVerificationAndQuery();
          }
        }).catch(err => {
          console.log('getapproval 接口出错', err)
        })
      }
    },
    // 监听按下
    readcardKeydown () {
      // 判断是否存在聚焦
      if (!this.isReadcard && this.$refs.readcardInput) {
        this.$refs.readcardInput.focus()
      }
    },
    removeKey () {
      document.removeEventListener('keydown', this.readcardKeydown)
    },
		// 切换机器人
		async changeRobot(i){
			this.robot = i
      await this.$nextTick()
			this.$refs.scrollArea.wrap.scrollTop = this.$refs.scrollArea.wrap.scrollHeight
		},
		// 机器人盒子Enter事件
		robotBoxEnter(){
			this.boxVisiable = true
		},
		// 机器人盒子leave事件
		robotBoxLeave(){
			this.boxVisiable = false
		},
		// 获取AI小易开启状态
		async getManagementList(){
			const obj = { curpage: 0, pagesize: 0, type: this.abilityType }
      obj.name = '人工智能查询'
      if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
        obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }   
			const { data } = await axiosBase(obj, "/api/getcompetencymanagelist")
			console.log(data)
			if(data){
				let status = data[0]['status']
				console.log(status)
				this.aiStatus = status ? true : false
        // 获取右侧ai小易高度
        setTimeout(() => {
          const examineEl = document.querySelector('.wisdomSubmit')
          if(!examineEl) return;
          console.log("examineEl==",examineEl.offsetHeight,examineEl);
          if (examineEl && this.aiIsOpen !== 0) {
            this.examineHeight = examineEl.offsetHeight
          }
        }, 2000);
			}
		},
    // ocr手动输入
    goFormManual(){
      this.toVeriQueryShow = false
      this.isShowocrSet = false
    },
    // ocr识别确认填写
    writeOcrData(data){
      const ocrConfig = this.ocrConfig
      // 把ocr识别的值填入表单
      // 明细组件
      if(Object.prototype.hasOwnProperty.call(this.ocrConfig, 'type')){
        for(const item of ocrConfig.ocrInfo.config){
          if(item.tempId === data.tempId){
            for(const subItem of item.fieldList){
              this.formdata[ocrConfig.type][ocrConfig.idx][subItem.backobject] = data.ocrData[subItem.fieldKey]
            }
            break
          }
        }
        if(ocrConfig.ocrInfo.savefile !== 'default_default'){
          this.formdata[ocrConfig.type][ocrConfig.idx][ocrConfig.ocrInfo.savefile].push(data.ocrImg)
        }
        const ind = this.ruleList.findIndex(it => (it.title + '_' + it.type) === ocrConfig.type)
        if (ind !== -1 && this.ruleList[ind].list && this.ruleList[ind].list.length > 0) {
          try {
            for(const item of ocrConfig.ocrInfo.config){
              if(item.tempId === data.tempId){
                for(const subItem of item.fieldList){
                  const xxind = this.ruleList[ind].list.findIndex(it => {
                    return (it.title + '_' + it.type) === (subItem.backobject)
                  })
                  if (xxind !== -1) {
                    this.$refs.widgetOneLayerRef.linkageMethChild(this.ruleList[ind].list, this.ruleList[ind].list[xxind], xxind, { key: ocrConfig.type, index: ocrConfig.idx })
                  }
                }
                break
              }
            }
            // this.$refs.widgetOneLayerRef.linkageMethChild(this.ruleList[ind].list, this.ruleList[ind].list[0], 0, { key: ocrConfig.type, index: ocrConfig.idx })
          } catch (err) { console.log(err) }
        }
      }
      else{
        for(const item of ocrConfig.config){
          if(item.tempId === data.tempId){
            for(const subItem of item.fieldList){
              this.formdata[subItem.backobject] = data.ocrData[subItem.fieldKey]
            }
            break
          }
        }
        if(ocrConfig.savefile !== 'default_default'){
          this.formdata[ocrConfig.savefile].push(data.ocrImg)
        }
      }
      this.toVeriQueryShow = false
      this.isShowocrSet = false
    },
    // ocr中台开关关闭
    closeOcrStatus(){
      this.ocrStatus = false
    },
    // ocr上传识别
    backUpload() {
      if(!this.ocrStatus){
        this.$message({
          message: '功能暂未开启，快去联系管理员吧～',
          type: 'warning'
        })
        return false
      }
      this.toVeriQueryShow = true
      this.isShowocrSet = true
      nextTick(() => {
        this.$refs.ocrSetRef.goStepFirst()
      })
    },
    // 明细新增打开ocr
    detailGoOcr(data){
      console.log("data==",data);
      this.toVeriQueryShow = true
      this.isShowocrSet = true
      nextTick(() => {
        this.$refs.ocrSetRef.onFormeParent(data.ocrInfo)
      })
      this.ocrConfig = data
    },
    // AI易录-扫码识别
    goScanImg(){
      const date = new Date()
      this.ocrTime = 'AI小易 ' + formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      this.scanOcr = true
      // 调用webSocket
      webSocketClass.constructor("wss://user.topeti.com/webmessage", this.websocketMessageHandler.bind(this));
      webSocketClass.connect('立即与服务器通信');
    },
    websocketMessageHandler(e) {
      if(e.action === "connected"){
        // 政和部署的是内网，所以手机上网页面调用小程序地址
        const imgUrl = this.$url === 'https://10.129.103.204:6677' || this.$url === 'https://zhxyy.topeti.com:6565' ? 'https://zhxyyxcx.topeti.com' : this.$url
        this.vueqrval = imgUrl + "/cust/ocr/index.html?code="+e.msg.token
        console.log("this.vueqrval==",this.vueqrval);
      }
      else if(e.action === "upload"){
        const previewWidth = this.pdwidth >= 80 ? 452 : 312;
        const imgUrl = this.$url === 'https://10.129.103.204:6677' ? 'https://zhxyy.topeti.com:6565' : this.$url
        this.dialogTableVisible = false
        this.fileOcrImg.name = e.msg.url
        this.fileOcrImg.response = '/userfiles/' + e.msg.url
        this.billImg = imgUrl + '/confiles/' + e.msg.url
        this.imgInfo = {
          width: e.msg.imgInfo.width,
          height: e.msg.imgInfo.height,
          percent: (previewWidth / e.msg.imgInfo.width).toFixed(2)
        };
        this.goAgain()
      }
    },
    // AI易录-查看识别结果
    goResult(){
      console.log(this.ocrResultArr);
      const date = new Date()
      let texts = this.ocrResultArr.map(item => item.text);
      this.ocrTime = 'AI小易 ' + formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      this.ocrStep = 3
      this.ocrCopyArr = texts.join('');
    },
    // AI易录-查看识别图片
    goResultImg(){
      this.ocrStep = 2
    },
    // AI易录-上传识别
    uploadImg() {
      let that = this
      const fileInput = document.getElementById('upload-file');
      const file = fileInput.files[0];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
      if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'PNG' || fileExtension === 'JPG' || fileExtension === 'JPEG') {
        let fileReader = new FileReader();
        const previewWidth = this.pdwidth >= 80 ? 452 : 312;
        fileReader.readAsDataURL(file); //根据图片路径读取图片
        fileReader.onload = function() {
          let base64 = this.result;
          let img = new Image();
          img.src = base64;
          img.onload = function() {
            that.imgInfo = {
              width: img.naturalWidth,
              height: img.naturalHeight,
              percent: (previewWidth / img.naturalWidth).toFixed(2)
            };
            console.log("宽：" + img.naturalWidth + " 高：" + img.naturalHeight + " 百分比：" + that.imgInfo.percent);
          }
        }
        const formData = new FormData()
        const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
        formData.append("file", file)
        let url = '/userfile/upload?accesstoken='+token
        let config = {
          headers:{
            'Content-Type':'multipart/form-data',
          },
        };
        Axios.post(url, formData, config)
          .then(res => {
            if(res.data){
              fileInput.value = ''
              that.fileOcrImg.name = res.data
              that.fileOcrImg.response = '/userfiles/' + res.data
              that.billImg = that.$url + '/confiles/' + res.data
              that.goAgain()
            }
          }).catch(err => {
            fileInput.value = ''
            console.log('图片识别失败，请重试', err)
        })
      } else {
        // 提示用户选择正确格式的文件
        that.$message.error('上传发票图片必须为.jpg .jpeg .png格式')
        return
      }
    },
    //  AI易录-重新识别（返回上一步）
    goStepOne(){
      this.ocrStep = 1
      this.ocrLoading = false
      this.checkStatus = true
      this.ocrResultArr = []
    },
    // AI易录-图片识别
    goAgain(){
      let that = this
      that.ocrLoading = true
      that.checkStatus = false
      that.ocrStep = 2
      // ocr识别图片
      ocrscan({
        file: that.billImg
      }).then(res => {
        that.ocrLoading = false
        that.checkStatus = true
        if (res.code === 0) {
          if(res.data.length == 0){
            that.$message.error('图片识别失败，请重试')
            return false
          }
          that.ocrResultArr = res.data
        } else {
          that.$message.error(res.msg)
        }
      }).catch(error => {
        console.log("error==",error);
        that.$message.error('图片识别失败，请重试')
        that.ocrStep = 1
        that.ocrLoading = false
        that.checkStatus = true
      })
    },
    // 人脸识别联动结果返回
    faceResult(param){
      console.log("param==",this.ruleList)
      console.log("this.formdata==",JSON.parse(JSON.stringify(this.formdata)));
      // this.toVeriQueryShow = false
      // this.isShowfaceSet = false
      // 遍历找到第一个联系人控件
      for (let i = 0; i < this.ruleList.length; i++) {
        if (this.ruleList[i].type === "relation-user") {
          this.$refs.widgetOneLayerRef.faceToUserData(this.ruleList[i]);
          this.$refs.widgetOneLayerRef.fromMultipleChoice(param.data)
          break;
        }
      }
      // this.$refs.widgetOneLayerRef.faceToUserData(this.ruleList[0])
      // this.$refs.widgetOneLayerRef.fromMultipleChoice(param.data)
      // 查询联动数据
      if (param.from === 'search') {
        let lastFormdata = JSON.stringify(this.formdata)
        let unchangedCount = 0
        const maxUnchanged = 3
        const interval = setInterval(() => {
          const currentFormdata = JSON.stringify(this.formdata)
          if (currentFormdata === lastFormdata) {
            unchangedCount++
          } else {
            unchangedCount = 0
            lastFormdata = currentFormdata
          }
          // 连续3次没变，认为数据稳定
          if (unchangedCount >= maxUnchanged) {
            clearInterval(interval)
            let copyformdata = JSON.parse(currentFormdata)
            this.$refs.faceSetRef.faceUserInfo(copyformdata)
          }
        }, 500)
      }
      // 传值并跳转提交表单页
      else{
        this.toVeriQueryShow = false
        this.isShowfaceSet = false
        this.$emit('refFlowshow', 0)
        this.$emit('getfaceAr', 0)
        this.$refs.widgetOneLayerRef.faceToJump()
      }
      console.log("formdata==",this.formdata)
    },
    // 切换人脸识别模式
    faceArChange(val){
      console.log("va;==",val)
      this.$refs.faceSetRef.faceArChange(val)
    },
    // 跳过人脸识别
    clickJump(){
      this.toVeriQueryShow = false
      this.isShowfaceSet = false
      // 清空字段值
      Object.keys(this.formdata).forEach(key => {
        const parts = key.split('_');
        const type = parts[1]; // 获取下划线后的字符串
        // 根据字段名清空数组或字段值
        if (type === 'relation-user' || type === 'image') {
          // 清空数组
          this.formdata[key] = [];
        } else {
          // 清空字段值
          this.formdata[key] = null;
        }
      });
      this.$emit('refFlowshow', 0)
      this.$emit('getfaceAr', 0)
    },
    handleCloseGroup (tag) {//分组的tag删除
      this.ctoArray.cto = this.ctoArray.cto.filter(item => !(item.folderId === tag.folderId));
      this.checkedArrGroup = this.checkedArrGroup.filter(item => !(item.folderId === tag.folderId));
    },
    handleCloseFlow(tag) {//组织架构的tag删除
      this.ctoArray.cto = this.ctoArray.cto.filter(item => !(item.organizationId === tag.organizationId));
      this.checkedFlowArr = this.checkedFlowArr.filter(item => !(item.organizationId === tag.organizationId));
    },
    handleCloseRole(tag) {//角色的tag删除
      this.ctoArray.cto = this.ctoArray.cto.filter(item => !(item.roleId === tag.roleId));
      this.checkedRoleArr = this.checkedRoleArr.filter(item => !(item.roleId === tag.roleId));
    },
    handleCloseUser(tag){
      this.ctoArray.cto = this.ctoArray.cto.filter(item => !(item.userId === tag.userId));
      this.checkedArrUser = this.checkedArrUser.filter(item => !(item.userId === tag.userId));
    },
    // 新增获取AI区域样式的方法
    getAiAreaStyle() {
      const w = this.flowshow === 1 && !this.modifyId && !this.modify ? this.baseSet.flowshow.width.substring(0, this.baseSet.flowshow.width.length - 2) : 0
      // 没开启流程
      if(w === 0){
        return {
          width: this.robotConfig && Object.keys(this.robotConfig).length && Number(this.robotConfig.fill.aiBoxWidth) !== 100 ? `${Number(this.robotConfig.fill.aiBoxWidth)}%` : '100%',
          height: this.examineHeight ? `${this.examineHeight}px` : '100%'
        }
      }
      else{
        // 获取主区域总宽度
        const mainArea = document.querySelector('.oaExamineAllArea');
        const mainareaWidth = mainArea ? mainArea.offsetWidth - w : 0;
        if(this.isAi === 2){
          return 'width:0'
        }
        else{
          // 判断是否需要50%宽度
          return Number(this.robotConfig.fill.aiBoxWidth) !== 100
            ? `width:${(mainareaWidth * (Number(this.robotConfig.fill.aiBoxWidth) / 100)) / 2}px`
            : `width:${mainareaWidth}px`
        }
      }
    },
    // 获取ai名称配置信息
    async getAiName(){
        const res = await getaimanageconfig()
        if (res.code === 0) {
          this.aiConfigList.forEach(ai => {
            res.data.forEach(item => {
              if (ai.number === item.number) {
                ai.name = item.name;
              }
            });
          });
        } else {
            this.$message.error(res.msg);
        }
    },
    startResize(e) {
      this.isResizing = true;
      this.startX = e.clientX;
      this.startWidth = document.querySelector('.ctoAllArea-ai').offsetWidth;
      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);

      // 添加禁止选择文本的样式
      document.body.style.userSelect = 'none';
    },

    handleResize(e) {
      if (!this.isResizing) return;

      const dx = this.startX - e.clientX;
      let newWidth = this.startWidth + dx;

      // 限制最小和最大宽度
      newWidth = Math.max(this.minWidth, Math.min(newWidth, this.maxWidth));

      // 更新 AI 区域宽度
      document.querySelector('.ctoAllArea-ai').style.width = `${newWidth}px`;

      // 更新主内容区域宽度
      const mainContent = document.querySelector('.wisdomSubmit');
      if (mainContent) {
        mainContent.style.width = `calc(100% - ${newWidth}px)`;
      }
    },

    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);

      // 移除禁止选择文本的样式
      document.body.style.userSelect = '';
    }
  },
  mounted () {
    this.modifyId = this.$route.query.modifyId || this.modify && this.modify.modifyId ? this.modify.modifyId : '';
    this.judgeScene();
    try{
      const userImg = JSON.parse(window.localStorage.getItem('userMsg'))
      let url = ''
      if (userImg.avatar) {
        if (userImg.avatar.includes('img-')) {
          url = this.$imgurl + userImg.avatar
        } else {
          const list = userImg.avatar.split('/')
          const num = list[list.length - 1]
          let format = `${num}.jpg`
          if (Number(num)>=36) {
            format = `${num}.svg`
          }
          url = `https://bigdata.topeti.com/PCRepository/middleground/avatar/${format}`
        }
      } else {
        if (userImg.sex && userImg.sex === '女') {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/16.jpg'
        } else {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg'
        }
      }
      // this.$set(this, 'userImg',  url)
      this.userImg = url
    } catch(e) {
      console.log("e==",e);
    }
    this.getManagementList()
    const that = this
    window.addEventListener('message', (event)=> {
      const message = event.data;
      if (message) {
        if (message.type === 'FORM_SAVE') {
          // 获取表单数据对象
          const formData = message.payload.formData;
          // console.log('接收到 iframe 保存的数据：', formData,);
          this.formdata = formData
          this.$nextTick(() => {
            this.submitForm('ruleForm')
          })
        }
        if (message.type === 'IFRAME_READY') {
          console.log('[父窗口] 收到 iframe 就绪信号');
          // 此时安全发送模式配置
          that.sendModeConfig('edit', that.formdata)
        }
      }
    });
  },
  watch: {
    coverVal: {
      deep: true,
      async handler(val) {
        if (val && this.isDoorAdd && typeof val === 'object') {
          try {
            let formdata = cloneDeep(this.formdata)
            if (formdata) {
              for (const i in val) {
                // 判断是否明细
                if (i.includes('details') && i.split('.').length !== 1) {
                  const its = i.split('.')
                  formdata[its[0]][0][its[1]] = val[i]
                } else if (i.includes('ready-widget')) {
                  // 判断是否为预约控件
                  const obj = val[i]
                  for (const idx in formdata[i]) {
                    formdata[i][idx] = {
                      ...formdata[i][idx],
                      ...obj[idx]
                    }
                  }
                } else {
                  // 不是明细直接赋值
                  formdata[i] = val[i]
                }
              }
              formdata = await defaultValuesForParameterTransmission(this.appProperty, formdata)
              this.formdata = formdata
              // 重新赋值之后再走联动
              if (!this.modifyId && !this.modify) {
                console.log(this.$refs.widgetOneLayerRef && this.$refs.widgetOneLayerRef.linkageInitiali,'this.$refs.widgetOneLayerRef && this.$refs.widgetOneLayerRef.linkageInitiali')
                setTimeout(() => { if (this.$refs.widgetOneLayerRef && this.$refs.widgetOneLayerRef.linkageInitiali) this.$refs.widgetOneLayerRef.linkageInitiali(-1) }, 500)
              }
              this.$forceUpdate()
            }
          } catch (e) {
            console.log('船只问题错误', e)
          }
        }
      },
    },
    informRelCto: {
      handler () {
        this.relCtoArrayCto();
      },
      deep: true,
    },
    iAgreePargam: {
      handler(val) {
        this.$emit('change-iagreepargam', val)
      },
      immediate: true
    },
    readcard: {
      immediate: true,
      handler (val) {
        console.log('')
        if (val.open) {
          document.addEventListener('keydown', this.readcardKeydown)
        } else {
          this.removeKey()
        }
      }
    },
    isAi: {
      immediate: true,
      handler (val) {
        if (val === 1 && !this.talkId) {
          // this.getAiName()
					for(let i = 0;i<this.robots.length;i++){
						switch(this.robots[i]){
							case 0:
								// ai 打开之后必然有返回一个 talkId
                // 易问模型不续费，部分用户已经配置了易问先注释，改成调用deepseek模型
								// this.getAi()
								break
							case 1:
								this.getWYYX()
								break
							case 2:
								this.getWYYX()
								break
						}
					}
        }
      }
    }
  },
  unmounted () {
    this.$store.commit('upOnly', 'false');
    // 清理事件监听
    document.removeEventListener('mousemove', this.handleResize);
    document.removeEventListener('mouseup', this.stopResize);
    if (this.$refs.mutualIndex) {
      this.$refs.mutualIndex.removeEventListener('dragover', this.handleDragOver);
    }
  }
}
</script>
<style lang="scss">
@import "../../assets/css/oaExamineInputWidget.scss";
.timeline-green .el-timeline-item__icon {
  color: #3faf67;
}
.timeline-add .el-timeline-item__icon {
  color: #4284ba;
}
.timeline-class .el-timeline-item__tail {
  top: 15px;
}
.timeline-class .el-timeline-item__node {
  top: 15px;
}
</style>
<style lang="scss" scoped>
.name-fqr {
  color: #4e86ff;
  padding-top: 5px;
  font-size: 12px;
}
:deep(.timeline-blue .el-timeline-item__icon) {
  color: #ffffff !important;
}
.link-config {
  display: flex;
  align-content: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  .link-config-title {
    padding-right: 10px;
  }
  .link-config-but {
    margin-right: 10px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: #4ea6ff;
      text-decoration: underline;
    }
  }
}

:deep(.readcard) {
  border-radius: 10px;
  .el-dialog__header {
    padding: 10px 20px;
    background-color: #EEEEEE;
    border-radius: 10px 10px 0 0;
    .el-dialog__title {
      font-size: 14px;
      color: #333333;
    }
    .el-dialog__headerbtn {
      font-size: 18px;
      color: #999999;
      top: 11px;
      right: 15px;
    }
  }
}
.readcard-img {
  margin-top: 36px;
  margin-bottom: 63px;
  text-align: center;
  img {
    max-height: 196px;
  }
}
.readcard-text {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  text-align: center;
  span {
    color: #4e86ff;
    padding-left: 5px;
    padding-right: 5px;
  }
}
.readcard-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.readcard-p {
  position: relative;
  padding-bottom: 53px;
}
.oaExamineInput {
  position: absolute;
  width: 100%;
  height: calc(100% - 44px);
  background: #f7f7f7;
  :deep(.oaExamineAudit) {
    height: 100%;
    width: 100%;
    .cur-detail {
      height: 100%;
      .oaExamineRight {
        .ctoArray-class {
          height: 100%;
        }
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
        .el-scrollbar__view {
          padding-left: 0 !important;
        }
      }
      .el-form {
        height: 100%;
        overflow-x: hidden;
        .cto-list {
          background-color: #fff;
          width: 100%;
          margin: 0;
          padding-left: 40px;
        }
        .widget-one-layer {
          height: 100%;
          width: 100%;
          box-sizing: border-box;
          padding-left: 0;
          padding-right: 0;
          margin-left: 0;
          .widget-one-layer-row {
            height: 100%;
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
        }
      }
    }
  }
  .no-repeated-submission {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    min-height: 300px;
    z-index: 2001;
    background-color: #fff;
    .repeatdialog {
      width: 100%;
      height: 100%;
      .repeatstyle {
        height: 100%;
      }
    }
  }
  .oaExamineAllArea {
    width: 100%;
    display: flex;
    height: 100%;
    .wisdomSubmit {
      height: 100%;
      // overflow-y: scroll;
      display: inline-block;
      position: relative;
      vertical-align: top;
      .inputBoxArea {
        height: calc(100% - 60px);
        // height: calc(100% - 50px);
        background: white;
        background-size: 100% 100%;
        :deep(.el-scrollbar__view, .form-class) {
          min-height: 100%;
          // height: 100%;
        }
      }
      .wisdomSubmitBox {
        width: 100%;
        height: 60px;
        position: absolute;
        left: 0;
        bottom: 0;
        .footer {
          width: calc(100% - 16px);
          height: 60px;
          padding: 0 14px 0 0;
          background: #fff;
          box-shadow: 0px 0px 4px 0px rgba(189, 189, 189, 0.5);
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .ai-insert {
            flex: 1;
            display: inline-flex;
            align-items: center;
            padding-left: 15px;
            .ai-input {
              margin: 0 10px;
              width: 60%;
              overflow: auto;
              font-size: 14px;
              color: #000;
              :deep(.el-input__wrapper) {
                padding: 1px 1px;
              }
              :deep(.el-input__inner) {
                background-color: #F3F4F6;
                color: #A2A3A5;
                border: 1px solid #F3F4F6;
                transition: all 0.3s;
                &:focus {
                  color: #34332E;
                  background-color: #EEF3FF;
                  border: 1px solid #4E86FF;
                }
              }
            }
            .ai-input-value {
              :deep(.el-input__inner) {
                color: #34332E;
                background-color: #EEF3FF;
                border: 1px solid #4E86FF;
              }
            }
            .btn-submit {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: 28px;
              height: 28px;
              margin-left: 5px;
              border-radius: 50%;
              flex-shrink: 0;
              background-color: #D6DEE8;
              cursor: not-allowed;
              i {
                font-size: 18px;
                color: #fff;
              }
              .paste-icon {
                font-size: 16px;
              }
            }
            .btn-submit-high {
              background-color: #4E86FF;
              cursor: pointer;
              &:hover {
                background-color: #66b1ff;
              }
            }
          }
          & > div {
            vertical-align: top;
            margin-right: 12px;
          }
          .btn-new-blue {
            position: relative;
            height: 32px;
            line-height: 32px;
            color: #fff;
            text-align: center;
            background: #4E86FF;
            padding: 0 17px;
            border-radius: 4px;
            border: 1px solid #4E86FF;
            box-sizing: border-box;
            cursor: pointer;
            input {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              z-index:3;
              opacity: 0;
              cursor: pointer;
            }
          }
          .btn-new-grey {
            height: 32px;
            line-height: 32px;
            color: #333;
            text-align: center;
            background: #fff;
            padding: 0 17px;
            border-radius: 4px;
            border: 1px solid #DCDFE6;
            box-sizing: border-box;
            cursor: pointer;
          }
          .btn-grey {
            background: #999;
            border: 1px solid #999;
          }
        }
      }
      .fiexd-canvas-bottom {
        margin: 0 auto;
        padding: 10px 0;
        display: flex;
        justify-content: center;
        background-color: #fff;
        .disabled-btn, .clickable-btn {
          width: 160px;
          border-radius: 4px;
          line-height: 40px;
          text-align: center;
          cursor: pointer;
        }
        .disabled-btn {
          color: #999999;
          background-color: #EEEEEE;
        }
        .clickable-btn {
          margin-left: 40px;
          color: #FFFEFF;
          background: linear-gradient(90deg, rgba(52, 165, 254, 1) 0%, rgba(97, 132, 245, 1) 100%);
        }
      }
    }
    .ctoAllArea {
      width: 24%;
      border-left: 1px solid #d8d8d8;
      background: white;
      display: inline-block;
      vertical-align: top;
      height: 100%;
      .ctoArray-class {
        width: 100%;
        overflow: hidden;
        height: 100%;
        p.title {
          margin: 0 15px;
          height: 44px;
          color: #333;
          line-height: 44px;
          border-bottom: 1px solid #e2e0dc;
        }
      }
    }
    .ctoAllArea-ai {
      position: relative;
      height: 100%;
      background: #fff;
      transition: width 0.1s;

      .resize-handle {
        position: absolute;
        left: 0;
        top: 0;
        width: 2px;
        height: 100%;
        z-index: 3;
        cursor: col-resize;
        background: transparent;

        &:hover {
          background: rgba(0, 0, 0, 0.1);
        }

        &:active {
          background: rgba(0, 0, 0, 0.2);
        }
      }
    }
    .ctoAllArea-flow {
      width: 100%;
      :deep(.el-timeline-item__tail) {
        top: 32px;
        height: calc(100% - 37px);
        left: 11px;
      }
      :deep(.el-timeline-item__node--large) {
        width: 24px;
        height: 24px;
        top: 0;
        background-color: #fff;
        border: 2px solid #F2F3F5;
        border-radius: 50%;
      }
      :deep(.el-timeline-item__wrapper) {
        padding-left: 36px;
      }
    }
  }
}

.input-page {
  width: 100%;
  height: 100%;
  .input-page-container {
    min-height: 700px;
    border: none;
  }
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-row-input-title {
  padding: 0;
  margin: 24px 0 0 0;
}

.el-row-input-title .title {
  line-height: 50px;
}

.input-box {
  margin-bottom: 20px;
}

.uploadBtn {
  border: 1px solid #ccc;
  width: 90px;
  background: #fafafa;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  color: #666;
}

.to ul li {
  padding: 4px 0;
  position: relative;
}
.to ul li .name {
  width: auto;
  min-width: 25%;
  padding-bottom: 10px;
  border-bottom: solid 1px #dcdcdc;
}
.to ul li .name .more-user-class {
  display: block;
  line-height: 1.5;
  border-radius: 4px;
  color: #666666;
  margin: 0px;
  padding: 1px 0px;
  float: left;
  background: none;
}
.to ul li .name .more-user-class:first-child:after {
  content: ",";
  clear: both;
  margin-right: 5px;
}
.to ul li .name .look-more-class {
  float: right;
  color: #965500;
  cursor: pointer;
  text-decoration: underline;
}

.to ul li .name {
  display: inline-block;
  vertical-align: middle;
  padding-left: 16px;
}

.to ul li .name span {
  background: #e1f0ff;
  color: #965500;
  margin: 0 4px;
  padding: 2px;
}

.to ul li .delBtn {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #ccc;
  margin-left: 10px;
  cursor: pointer;
}

.mode-cto-class ul {
  padding: 15px;
}
.mode-cto-class ul li {
  width: 50%;
  overflow: hidden;
  float: left;
  position: relative;
}
.mode-cto-class ul li.user::before {
  font-family: "iconfont" !important;
  vertical-align: middle;
  color: #3aa7e1;
  font-size: 16px;
  content: "\e68e";
}
.mode-cto-class ul li.org::before {
  font-family: "iconfont" !important;
  vertical-align: middle;
  color: #3faf67;
  font-size: 16px;
  content: "\e67d";
}
.mode-cto-class ul li span {
  display: inline-block;
  vertical-align: middle;
  margin: 12px 3px;
  color: #666;
  padding: 2px 8px;
  background: #f4f3f3;
  max-width: 105px;
}
.mode-cto-class ul li span:nth-child(1) {
  background: none;
  color: #333;
}
.mode-cto-class ul li span .iconfont {
  padding-right: 4px;
  font-size: 18px;
}
.mode-cto-class ul li .delBtn {
  position: absolute;
  right: 10px;
  top: 14px;
  cursor: pointer;
  font-size: 18px;
  color: #999;
}

.details-main:first-child {
  border-top: 1px solid #ddd;
}

.details-main {
  padding: 15px 10px;
  border-bottom: 1px solid #ddd;
}

.color-blue {
  color: #3a8ee6;
  border-color: #3a8ee6;
  float: right;
}

.details-title {
  margin-bottom: 15px;
}

.details-title span:last-child {
  cursor: pointer;
  color: #ff2b45;
}

.el-icon-plus {
  color: #ddd;
  line-height: 78px;
}

.errorMsg {
  font-size: 12px;
  color: red;
  padding-left: 10px;
  vertical-align: middle;
}

.repeatstyle {
  text-align: center;
  padding-top: 10%;
}
.repeatstyle p {
  font-size: 16px;
  padding: 10px 0;
}

/**11 19日的样式**/
.blueBtn {
  /* text-decoration: underline; */
  color: #4284ba;
  cursor: pointer;
}
.process .name {
  font-weight: bold;
  display: flex;
  align-items: center;
}
.process .orgname {
  padding: 10px 0;
  margin-left: 10px;
}
.process .close-right {
  text-align: right;
}
.process .close-right i {
  color: #999;
  font-size: 20px;
}

/** 弹窗 */
.fromeFrameScuess {
  width: 100%;
  height: calc(100% - 60px);
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 99999;
}

.fromeFrameScuess div {
  text-align: center;
}

.fromeFrameScuess div:first-child {
  padding-top: 200px;
  padding-bottom: 50px;
}

.fromeFrameScuess div p {
  font-size: 20px;
}

.fromeFrameScuess div p i {
  font-size: 50px;
  color: $base-second-color;
}

.fromeFrameScuess1 {
  max-width: 1200px;
  left: 0;
  transform: translateX(0);
  height: 100%;
  position: relative;
  padding-bottom: 30px;
}
.is-submit-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2001; // 和弹窗同级
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.split-submit {
  width: 100% !important;
  height: 100% !important;
  position: absolute !important;
}
.sideslip-submit {
  width: 100% !important;
}
// pc弹窗高度-自适应
:deep(.dialog-height-auto)  {
  min-height: inherit;
  .oaExamineInput {
    position: inherit;
    .oaExamineAllArea {
      .wisdomSubmit {
        .wisdomSubmitBox {
          position: inherit;
        }
      }
    }
  }
}
.cto-list {
  width: calc(100% - 40px);
  margin: 0 auto;
  padding-bottom: 24px;
  .cto-row {
    background: #fff;
    .inner {
      display: flex;
      align-items: center;
      padding: 10px 0;
      .title {
        display: block;
        flex: 0 0 120px;
        height: 46px;
        line-height: 46px;
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }
      .list-detail {
        position: relative;
        flex: 1;
        min-width: 0;
        padding-right: 71px;
        box-sizing: border-box;
        .list-box {
          position: relative;
          width: 100%;
          min-height: 44px;
          padding: 5px 80px 5px 5px;
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid #CBCBCB;
          :deep(.el-input) {
            width: 105px;
          }
          :deep(.el-input__wrapper) {
            box-shadow: none;
            padding: 1px 0;
          }
          :deep(.el-input__inner) {
            height: 32px;
            line-height: 32px;
            padding: 0 0 0 5px;
            border: none !important;
          }
          .fast-btn {
            position: absolute;
            right: 0;
            top: 50%;
            width: 76px;
            margin-top: -19px;
            a {
              position: relative;
              float: left;
              display: block;
              width: 38px;
              height: 38px;
              line-height: 38px;
              text-align: center;
              color: #4e86ff;
              cursor: pointer;
              &::after{
                content: "";
                position: absolute;
                top: 9px;
                left: 0;
                width: 1px;
                height: 20px;
                background-color: #ccc;
              }
            }
          }
          :deep(.choose-type1) {
            background: #FFE7E8;
            color: #FC6D70 !important;
            padding:2px 5px;
            border-radius: 2px;
            margin-left: 5px;
          }
          :deep(.choose-type2) {
            background: #FFEADB;
            color: #FB851C !important;
            padding:2px 5px;
            border-radius: 2px;
            margin-left: 5px;
          }
          .no-data {
            display: block;
            line-height: 32px;
          }
        }
        .blueBtn {
          position: absolute;
          right: 0;
          top: 0;
          display: block;
          height: 46px;
          line-height: 46px;
          color: #5086FF;
          font-size: 14px;
        }
      }
    }
    .inner-layout {
      display: block;
      .title {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
.drwaer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  .loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    position: fixed;

    transform: translate(-50%, -50%);
    left: 44%;
    top: 38%;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background: linear-gradient(#1a98ca, #1a98ca),
      linear-gradient(90deg, #ffffff33 1px, transparent 0, transparent 19px),
      linear-gradient(#ffffff33 1px, transparent 0, transparent 19px),
      linear-gradient(transparent, #1a98ca);
    background-size: 100% 1.5%, 10% 100%, 100% 8%, 100% 100%;
    background-repeat: no-repeat, repeat, repeat, no-repeat;
    background-position: 0% 0%, 0 0, 0 0, 0 0;
    /* 初始位置 */
    clip-path: polygon(0% 0%, 100% 0%, 100% 1.5%, 0% 1.5%);
    /* 添加动画效果 */
    animation: move 2s infinite linear;
  }
}
</style>
